(function($) {
  var ONCE = "___ONCE___";
  
  var Once = function(elem) {
    this.elem = elem;
    this.data = [];
  };
  var _ = Once.prototype;
  
  _.deferred = function(name) {
    if (!name) { return $.Deferred().reject(); }
    var result = this.data[name];
    if (!result) {
      var elem = this.elem;
      result = this.data[name] = $.Deferred().always(function() {
        $(elem).trigger(name);
      });
    }
    return result;
  };
  
  _.reset = function(name) {
    if (!name) { return; }
    var existing = this.data[name];
    if (existing) {
      existing.reject();
      this.data[name] = null;
    }
    return this.deferred(name);
  };
  
  Once.get = function($elem) {
    var result = $elem.data[ONCE];
    if (!result) { result = $elem.data[ONCE] = new Once($elem[0]); }
    return result;
  }
  
  $.fn.extend({
    once: function(name) {
      var once = Once.get(this);
      return name === undefined ? once : once.deferred(name).promise();
    }
  });
})(jQuery);
(function($) {
	const FAIL = "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==";
	$.extend({
		imageload: function(src) {
			var result = $.Deferred();
			var img = $('<img onerror="this.src=\'' + FAIL + '\'" src="' + src + '">');
			function check() {
				img.off('load');
				var succeeded = !(img.attr('src') === FAIL);
				if (succeeded) {
					result.resolve(img.get(0));
				} else {
					result.reject({
						"src": src,
						"error": "Load failed"
					});
				}
			}
			if (img.get(0).complete) {
				check();
			} else {
				img.on('load', check);
			}
			return result.promise();
		}
	});
})(jQuery);

(function($) {
  var version_match = $(document.currentScript).attr("src").match(/^.*\-([\w]+)\.[\w\.]+$/);
  var version = (version_match ? version_match[1] : null) || "1";
  $.extend({ site: { version: ("v" + version) } });
})(jQuery);

//=require site-blank.js

(function($) {
  var _;
  
  // Running
  var Running = function(poll) {
    this.poll = poll;
    this.cancelled = false;
  };
  _ = Running.prototype;
  
  _.cancel = function() {
    if (!this.cancelled && !this.discarded) {
      this.cancelled = true;
      if (this.poll.running === this) { delete this.poll.running; }
      if (this.request) { this.request.abort(); delete this.request; }
      if (this.timeout) { clearTimeout(this.timeout); }
    }
  };
  
  _.discard = function() {
    if (!this.discarded) {
      this.discarded = true;
      if (this.poll.running === this) { delete this.poll.running; }
    }
  };
  

  // Poller
  var Poller = function(controller, id, def, callback, options) {
    this.controller = controller;
    this.id = id;
    this.def = typeof def === "object" ? Object.assign({}, def) : {url: ("" + def)};
    this.def.cache = false;
    this.callback = callback;
    if (typeof options === "number") {
      this.delay = options;
    } else if (typeof options === "object") {
      this.delay = "delay" in options && typeof options.delay === "number" ? options.delay : 5000;
      this.manual = "manual" in options ? !!options.manual : false;
    }
  };
  _ = Poller.prototype;
  
  _.poll = function(delays) {
    if (!this.controller.isStopped) {
      this.schedule(delays || 0);
    }
  };
  
  _.start = function(millisSpentBlurred) {
    if (!this.manual) {
      this.schedule(millisSpentBlurred >= 3000 ? [100] : undefined);
    }
  };
  
  _.stop = function() {
    if (this.running) { this.running.cancel(); }
  };
  
  _.schedule = function(delays) {
    if (this.running) { this.running.cancel(); }
    var running = this.running = new Running(this);
    
    var millis;
    if (Array.isArray(delays)) {
      millis = delays.shift();
      if (delays.length == 0) { delays = undefined; }
    } else if (typeof delays === "number") {
      millis = delays;
    } else {
      delays = millis = undefined;
    }
    
//     console.log("[poll::" + this.id + "::schedule] delay = " + millis);
    
    if (millis === undefined) { millis = this.delay; }
    
    if (millis > 0) {
      running.timeout = setTimeout((function() {
        delete running.timeout;
        this.execute(delays, running); // Can't have been cancelled, otherwise already killed by timeout.
      }).bind(this), millis);
    } else {
      this.execute(delays, running);
    }
  };
  
  _.execute = function(delays, running) {
    this.lastPollTime = Date.now();
    var def = this.def;
    var request = running.request = $.ajax(def);
    request
    .done((function(data, textStatus) {
      if (running.cancelled) { return; }
      var result = this.callback(data, textStatus, request, running);
      if (running.cancelled) { return; }
      
      if (result) {
        // If the result is a $.Deferred, then bind(this) doesn't work for the function
        // passed to always(). So must nest it.
        var completion = (function() {
          this.finished(undefined, running); // After a reload, discard the custom delays list.
        }).bind(this);
        return result.always(function() {
          completion();
        });
      } else {
        this.finished(delays, running);
      }
    }).bind(this))
    .fail((function(jqXHR, textStatus, errorThrown) {
      if (!running.cancelled) {
        console.error("[poll::" + this.id + "::error] [" + def.url + "] " + textStatus + (errorThrown ? ": " + errorThrown : ""));
      }
      this.finished(delays, running);
    }).bind(this));
  };
  
  _.finished = function(delays, running) {
    if (!running.cancelled) {
      running.discard();
      if (!this.manual) {
        this.schedule(delays);
      }
    }
  };  


  // Controller
  var Controller = function() {
    this.onWindowFocus = this.onWindowFocus.bind(this);
    this.onWindowBlur = this.onWindowBlur.bind(this);
    this.polls = {};
        
    this.hasFocus = true;
    this.isStopped = true;
    
    $(window).on("focus", this.onWindowFocus);
    $(window).on("blur", this.onWindowBlur);
    $(window).on("unload", this.onWindowBlur);
    
    $(document).ready(function() {
      if (this.hasFocus) {
        this.onWindowFocus();
      }
    }.bind(this));
  };
  _ = Controller.prototype;
  
  _.onWindowFocus = function() {
    this.hasFocus = true;
    if (!$.isReady) { return; }
    this.isStopped = false;
        
    var millisSpentBlurred = this.lastBlurTime ? Date.now() - this.lastBlurTime : 0;
    for (var id in this.polls) {
      var poll = this.polls[id];
      poll.start(millisSpentBlurred);
    }  
  };
  
  _.onWindowBlur = function() {
    this.isStopped = true;
    this.hasFocus = false;
    this.lastBlurTime = Date.now();
    
    for (var id in this.polls) {
      var poll = this.polls[id];
      poll.stop();
    }
  };
  
  _.add = function(id, def, callback, options) {
    this.remove[id];
    var poll = this.polls[id] = new Poller(this, id, def, callback, options);
    if (!this.isStopped) {
      poll.start();
    }
    return poll;
  };
  
  _.remove = function(id) {
    var poll = this.polls[id];
    delete this.polls[id];
    if (poll) { poll.stop(); }
  };
  
	$.site.Poll = new Controller();
})(jQuery);
(function($) {
  var _;
  var DEFAULT_TIMEOUT = 1000*60*60*12; // 12 hours
  
  function Page(pages, hash) {
    this.pages = pages;
    this.setHash(hash);
    pages.onNewPage(this);
  }
  _ = Page.prototype;
  
  _.setHash = function(hash) {
    if (!hash || !(typeof hash === "string")) {
      hash = "";
    } else {
      hash = hash.trim();
      // Must start with '#'
      if (hash.length > 0 && !hash.startsWith("#")) { hash = "#" + hash; }
      // Remove excess '/' characters
      hash = hash.replace(/^(.+?)\/*?$/, "$1").replace(/\/\/+/g, '/').replace(/^#\//, '#');
      if (hash === "#") { hash = ""; }
    }
    this.hash = hash;
    
    // Replace mangled hash with clean hash (e.g. too many slashes)
    if (hash !== location.hash) {
      history.replaceState(undefined, undefined, location.href.split("#", 2)[0] + hash);    
    }    
    
    var components = (hash.startsWith("#") ? hash.substring(1) : hash).split("?", 2);
    this.path      = components.shift();
    this.qs        = components.shift();    
    var source     = this.source();
    this.valid     = source && !!source[0];
    
    if (this.valid) {    
      this.href = source.attr('href') || source.attr('data-href');
      this.type = source.attr('data-page');
    }
  };
  
  _.source = function() {
    if (this.hash.length == 0) { return null; }
    return $('[data-page][href$="' + this.hash + '"], [data-page][data-href$="' + this.hash + '"], [data-page][data-href-alt*="' + this.hash + '"]').first();
  };
  
  function Pages() {
    this._enabled = false;
    this.onHashChange = this.onHashChange.bind(this);
  }
  _ = Pages.prototype;
  
  _.init = function() {
    var options = this.options;
    if (options && options.initPages) {
      options.initPages(this);
    }
  };
  
  _.start = function(options) {
    if (options) { this.options = options; }
    this.enabled(true);
  };
  
  _.showPage = function(hash) {
    if (location.hash === hash) {
      this.onHashChange();  
    } else {
      location.href = hash;
    }
  };
  
  _.shouldReload = function(page) {
    var options = this.options;
    var timeout = DEFAULT_TIMEOUT;
    if (options && options.timeout !== undefined) { timeout = 0 + options.timeout; }
    if (timeout > 0 && this.startTime) {
      var elapsed = Date.now() - this.startTime;
      if (elapsed > timeout) {
        return true;
      }
    }
    
    if (options && options.shouldReloadPage) {
      return options.shouldReloadPage(page);
    } else {
      return false;
    }
  };
  
  _.onNewPage = function(page) {
    var options = this.options;
    if (options && options.initPage) {
      options.initPage(page);
    }  
  };
  
  _.onHashChange = function() {
    var page = new Page(this, location.hash);
    this.pages = page;

    // Reload from server
    if (this.shouldReload(page)) {
      // Don't reload everything, just HTML page (should be set to no-cache)
      location.reload(false);
      
    // Fire event
    } else {
      $(window).trigger("page.pages", page);
    }
  };
  
  _.ifStillOnSamePage = function(func) {
    var page = this.page;
    return function() { if (this.page === page) { func(); }  }
  };
  
  _.enabled = function(enabled) {
    var wasEnabled = this._enabled;
    if (enabled === undefined) { return wasEnabled; }
    
    enabled = !!enabled;
    if (enabled === wasEnabled) { return; }
    this._enabled = enabled;
    
    if (enabled) {
      $(document).ready(function() {
        if (this._enabled) {
          var wasStarted = this.startTime !== undefined;
          if (!wasStarted) {
            this.startTime = Date.now();
            this.init();
          }
          $(window).on('hashchange.pages', this.onHashChange);
          $(window).on('onpopstate.pages', this.onHashChange);
          if (!wasStarted) { this.onHashChange(); }
        }
      }.bind(this));
    } else {
      $(window).off('hashchange.pages').off('onpopstate.pages');
    }
  };
  
  Pages.Page = Page;
  
  $.extend({
    pages: new Pages()
  });
})(jQuery);


(function($) {
  var _;
  var Poll = $.site.Poll;
  
  var PagesPollOptions = function() {};
  _ = PagesPollOptions.prototype;
  
	_.initPages = function(pages) {
	  var ajax = {url: location.href, method: "HEAD"};
    this.stalePoller = Poll.add("pages-stale", ajax, function(data, statusText, request) {
      var modified = request.getResponseHeader("Last-Modified");
      if (!this.isEqualLastModified(modified)) {
        this.stale = true;
      }
    }.bind(this), { manual: true });
	};
	
	_.timeout = 1000*60*60*24; // 1 day
	
	_.shouldReloadPage = function(page) {
	  if (this.stale) { return true; }
	  if (!page.pages.startTime) { return false; }
	  
	  var lastPollTime = this.stalePoller.lastPollTime || page.pages.startTime;
	  var elapsed = Date.now() - lastPollTime;
	  if (elapsed > 1000 * 10) { this.stalePoller.poll(); }
	  
	  return false;
	}	;
	
	_.isEqualLastModified = function(lastModified) {
	  var d1 = new Date(document.lastModified);
	  var d2 = new Date(lastModified);
	  if (isNaN(d2)) { return false; }
	  
	  // Document.lastModified returns date without timezone, but ajax request lastModified
	  // header includes timezone. As of 6-Oct-2019, for document.lastModified,
	  // Firefox leaves the header as-is (minus the timezone), whereas Safari converts it
	  // to browser's timezone. E.g. Firefox returns "10/06/2019 20:00" but Safari returns
	  // "10/06/2019 22:00", whereas the server's true last modified is
	  // "06 Oct 2019 20:00 GMT". So do a slightly flaky calculation to allow for this.
	  // Note this will give a false positive in situations where the file is changed on the
	  // server, and the difference in times between the old file and the new one happens to
	  // exactly match any user's timezone difference.
	  if (d1.getTime() === d2.getTime()) { return true; }
    if (d1.getTime() - (d1.getTimezoneOffset() * 60 * 1000) === d2.getTime()) { return true; }
	  return false;
	};
  
	$.site.PagesPollOptions = PagesPollOptions;
})(jQuery);

(function($) {
  var height = 0;
  
  function onScroll() {
    if ($(document).height() - (Math.floor($(window).scrollTop() + $(window).height())) < height) {
      $.onScrollBottom.enabled(false);
		  $(window).trigger("scroll-bottom");
    }
  }
  
	$.extend({
		onScrollBottom: {
		  enabled: function(value) {
		    if (value === undefined) { return height > 0; }
		    value = parseFloat(value, 10);
		    if (isNaN(value)) { value = 0; }
		    if (height === value) { return; }
		    var wasEnabled = height > 0;
		    height = value;
		    if (value > 0) {
		      if (!wasEnabled) {
            $(window).on("scroll", onScroll);
            $(document).ready(onScroll);
          }
		    } else {
		      $(window).off("scroll", onScroll);
		    }
		  }
    }
	});
} (jQuery));


//=require ../../../src/js/poll.js
//=require site-blank.js
(function($) {
  $.fn.extend({
    findTop: function(selector) {
      return this.find(selector).add(this.filter(selector));
    }
  });
} (jQuery));

(function($) {
  function _toggleEnabled($target, enabled) {
    $target.prop("disabled", !enabled).prop("readonly", !enabled);
  }

  $.fn.extend({
    formInputs: function() {
      return this.findTop(":input");
    },

    toggleEnabled: function(enabled, opts) {
      // By default, when enabling always re-disable killed.
      // This handles following sequence:
      // 1. toggleEnabled(true, { canEnableKilled: true  }) // killed are enabled
      // 2. toggleEnabled(true)                             // killed must be re-disabled
      if (enabled && !(opts && opts.canEnableKilled)) {
        _toggleEnabled(this.filter(     "[data-killed]" ), false);
        _toggleEnabled(this.filter(":not([data-killed])"), true);
      } else {
        _toggleEnabled(this, enabled);
      }
      return this;
    },

    toggleKilled: function(killed) {
      _toggleEnabled(this, !killed);
      return this.attr("data-killed", killed ? 1 : null);
    },
  });
} (jQuery));


(function($) {
  var defaultFieldsDef = {
    getFieldNameForName: function(name) { return name; },
    getNameForFieldName: function(name) { return name; }
  };
  
  var defaultSubmitDef = {
    submit: function(form) { return form.$().submit(); }
  };

  var Form = $.site.Form = function(id, fieldsDef, submitDef) {
    this.id = id;
    this.fieldsDef = fieldsDef || defaultFieldsDef;
    this.submitDef = submitDef || defaultSubmitDef;
    this.fields = [];
  };
  
  var _ = Form.prototype;
  
  _.$ = function() { return $("#" + this.id); };
  _.$inputs = function() { return this.$().formInputs(); };
  
  _.init = function(config) {
    if ('init' in this.fieldsDef) { this.fieldsDef.init(this, config); }
    if ('init' in this.submitDef) { this.submitDef.init(this, config); }
    this.read();
  };
    
  _.getFieldNameForName = function(name) { return this.fieldsDef.getFieldNameForName(name, this); };
  _.getNameForFieldName = function(name) { return this.fieldsDef.getNameForFieldName(name, this); };  
  _.submit = function() { return this.submitDef.submit(this); };
    
  _.enable = function(enabled) {
    var $fields = this.$();
    if (arguments.length > 1) {
      var selector = "";
      for (var i = 1; i < arguments.length; i++) {
        if (arguments[i]) { selector += (selector.length == 0 ? "" : ", ") + "[name=\"" + this.getFieldNameForName(arguments[i]) + "\"]"; }
      }
      $fields = $fields.find(selector);
    }
    $fields.formInputs().toggleEnabled(enabled);
  };
  
  _.reset = function() { this.fields = []; this.$()[0].reset(); }
  
  _.read = function() {
    var fields = this.fields = this.$().serializeArray();
    fields.forEach(function(field) { field.name = this.getNameForFieldName(field.name); }, this);
  };
  
  _.write = function(fields) {
    if (!Array.isArray(fields)) { this.fields = []; this.$()[0].reset(); return; }
    
    var $form = this.$();
    fields.forEach(function(field) {
      var $input = $form.find("input[name=\"" + this.getFieldNameForName(field.name) + "\"]");
      var type = $input.attr("type");
      if (type === "checkbox") {
        $input.prop("checked", !!field.value);
      } else if (type === "radio") {
        $input.each(function() {
          var $this = $(this);
          $this.prop("checked", $this.attr("value") === field.value);
        });
      } else {
        $input.val((field.value === undefined ? "" : field.value));
      }
    }, this);
    
    this.read();
  };
  
  _.log = function(message) {
    message = message && message.length > 0 ? message + "\n" : "";
    console.log(message + this.toString());
  };

  Form.stringify = function(data) {
    return JSON.stringify(data, function(k,v) {
      if (typeof v === "object" &&
          'name' in v &&
          'value' in v &&
          Object.keys(v).length == 2 &&
          v.name !== "name" &&
          v.value !== "value") {
        return "" + v.name + ": " + v.value;
      }
      return v;
    }, 1);
  };
  
  _.toString = function() { return "[#" + this.id + "]\n" + Form.stringify(this.fields); };
} (jQuery));
(function($) {
  function _toInt(num) {
    if (num === undefined) { return NaN; }
    if (num === "") { return NaN; }
    if (isNaN(num)) { return NaN; }
    if (typeof num !== "number") { num = parseInt(num,10); }
    return Math.floor(num);
  }
  
  function _toString(num) {
    return isNaN(num) ? "" : num;
  }

  function _onChange() {
    var $input = $(this);
    var value = $input.val();
    if (value === undefined || value === "") {
      $input.val($input.attr("defaultValue") || $input.attr("placeholder"));
    }
  }
  
  $.fn.extend({
    numberRange: function(defaultValue, min, max) {
      defaultValue = _toInt(defaultValue);
      min = _toInt(min);
      max = _toInt(max);
      if (isNaN(defaultValue)) {
        defaultValue = min;
      } else if (!isNaN(min) && defaultValue < min) {
        defaultValue = min;
      } else if (!isNaN(max) && defaultValue > max) {
        defaultValue = max;
      }
      defaultValue = _toString(defaultValue);
      min = _toString(min);
      max = _toString(max);
      return this.each(function() {
        var $input = $(this);
        $input
          .attr("defaultValue", defaultValue)
          .attr("placeholder", defaultValue)
          .attr("min", min)
          .attr("max", max)
          .on("change", _onChange);
        if (isNaN(_toInt($input.val()))) { $input.val(defaultValue); }
      });
    }
  });
} (jQuery));

//=require site-blank.js

(function($) {
  var Singleton = $.site.Singleton = function(object) {
    this.define = this.define.bind(this);
    this.define(object);
  };
  Singleton.prototype.define = function(object) {
    if (!object) { return; }
    for (var key in object) {
      if (key === "constructor") { continue; }
      var value = object[key];
      if (typeof value === "function") { value = value.bind(this); }
      this[key] = value;
    }
    return this;
  };
})(jQuery);

(function($) {
  $.site.Utils = new $.site.Singleton();
})(jQuery);

(function($) {
  $.site.Utils.define({
    isDev: location.href.indexOf("local") >= 0 ||
           location.href.indexOf("192.") >= 0
  });
})(jQuery);
//=require utils-blank.js

(function($) {
  $.site.Utils.define({
    meta: function(name) { return $('meta[name=' + name + ']').attr('content'); }
  });
})(jQuery);

(function($) {
  var _;
  var Utils = $.site.Utils;

  var Config = $.site.Config = function() {};
  _ = Config.prototype;

  _.init = function() {
    this.urls = {
      readings:    Utils.meta('meter-readings'     + (Utils.isDev ? '-dev' : '-prod')),
      lastUpdated: Utils.meta('meter-lastUpdated'  + (Utils.isDev ? '-dev' : '-prod')),
      submit:      Utils.meta('meter-submit'       + (Utils.isDev ? '-dev' : '-prod'))
    };

    if (!this.urls.fastReadings) { this.urls.fastReadings = this.urls.readings; }
    this.logging = Utils.meta('logging') === 'true';
    this.people = $("#g-form [data-person]").map(function() {
      return {
        initial: $(this).attr("data-person"),
        image:   $(this).attr("data-image"),
      };
    }).get();

    // Edit pages
    var defaultPanel;
    var byName = {};
    var all = $("#edit-form .s-edit-question").get().map(function(elem, i) {
      var $elem = $(elem);
      var id = elem.id;
      var name = id.substring("edit-question-".length);
      var buttonName = $elem.attr("data-button-name");
      var panel = { index: i, name: name, id: id, buttonName: buttonName };
      if ($elem.attr("data-default")) { defaultPanel = panel; }
      byName[name] = panel;
      return panel;
    });
    this.editPanels = {
      byName:byName,
      all:all,
      defaultPanel:defaultPanel
    };
  };
} (jQuery));

//=require ../../../src/js/site-blank.js
//=require ../../../src/js/jquery-findtop.js
//=require ../../../src/js/jquery-forminputs.js
//=require utils-blank.js

(function($) {
  var _ = {};
  
  var isBlankString = /^\s*$/;
  var isFalseString = /^\s*(?:false|n|no|0)\s*$/i;
  var isISODate = /^\d\d\d\d-\d\d-\d\d$/;
  var parseIntBaseTen = function(value) { return parseInt(value, 10); };

  function toNumber(value, subst, parser) {
    if (typeof value !== "number") {
      value = parser(value);
    }
    return isNaN(value) ? subst : value;
  }    
  
  _.toBool = function(value, subst) {
    if (typeof value === "string" && value.length > 0) {
      if (isBlankString.test(value) || isFalseString.test(value)) { value = false; }
    }
    // Allow return undefined instead of converting to false
    return value === undefined ? subst : !!value;
  };
  
  _.toInt   = function(value, subst) { return toNumber(value, subst, parseIntBaseTen); };
  
  _.toFloat = function(value, subst) { return toNumber(value, subst, parseFloat); };
  
  _.toString = function(value, subst) { return value === undefined || value === null ? subst : "" + value; };
  
  _.toDate = function(value, subst) {
    if (value === undefined || value === null) { return subst; }
    if (!(value instanceof Date)) {
      if (typeof value !== "number") {
        value = Date.parse(value);
      }
      value = new Date(value);
    }
    return this.toMidnight(value) || subst;
  };
  
  _.toMidnight = function(date) {
    if (!(date instanceof Date) || isNaN(date.getTime())) { return undefined; }
    return (date.getHours() == 0 &&
            date.getMinutes() == 0 &&
            date.getSeconds() == 0 &&
            date.getMilliseconds() == 0) ? date : new Date(date.getFullYear(), date.getMonth(), date.getDate());
  };
    
  _.toDay   = function(num, subst) { return (num = this.toInt(num)) !== undefined && num >= 1 && num <= 31 ? num : subst; };
  _.toMonth = function(num, subst) { return (num = this.toInt(num)) !== undefined && num >= 1 && num <= 12 ? num - 1 : subst; };
  _.toYear  = function(num, subst) { return (num = this.toInt(num)) !== undefined ? num : subst; };
  
  _.toDateWithComponents = function(year, month, date, subst) {
    return this.toDate(new Date(
      (year = this.toYear(year)) !== undefined ? year : (subst && subst.getFullYear()),
      (month = this.toInt(month)) !== undefined && (month = this.toMonth(month + 1)) !== undefined ? month : (subst && subst.getMonth()),
      (date = this.toDay(date)) !== undefined ? date : (subst && subst.getDate())
    ));
  };
  
  function _withLeadingZero(validInt, withZero) {
    if (!withZero || validInt >= 10) {
      return "" + validInt;
    } else {
      return "0" + validInt;
    }
  }
  
  // Note: following function has too many brackets to eliminate gulp lint error "no-cond-assign"
  _.withLeadingZero    = function(num)  { return (num = this.toInt(num)) !== undefined ? _withLeadingZero(num, true) : ""; };
  _.formatDay          = function(num,  fmt) { return (num = this.toDay(num)) !== undefined ? _withLeadingZero(num, fmt === "dd") : ""; };
  _.formatMonth        = function(num,  fmt) { return (num = this.toInt(num)) !== undefined && (num = this.toMonth(num + 1)) !== undefined ? _withLeadingZero(num + 1, fmt === "mm") : ""; };
  _.formatYear         = function(num,  fmt) { return (num = this.toYear(num)) !== undefined && (num = _withLeadingZero(num, true)) ? (fmt === "yy" ? num.slice(-2) : num) : ""; };
  _.formatDateDay      = function(date, fmt) { return this.formatDay((date ? date.getDate() : undefined), fmt); };
  _.formatDateMonth    = function(date, fmt) { return this.formatMonth((date ? date.getMonth() : undefined), fmt); };
  _.formatDateYear     = function(date, fmt) { return this.formatYear((date ? date.getFullYear() : undefined), fmt); };
  _.formatISODay       = function(num)  { return this.formatDay(num, "dd"); };
  _.formatISOMonth     = function(num)  { return this.formatMonth(num, "mm"); };
  _.formatISOYear      = function(num)  { return this.formatYear(num, "yyyy"); };
  _.formatISODateDay   = function(date) { return this.formatISODay((date ? date.getDate() : undefined)); };
  _.formatISODateMonth = function(date) { return this.formatISOMonth((date ? date.getMonth() : undefined)); };
  _.formatISODateYear  = function(date) { return this.formatISOYear((date ? date.getFullYear() : undefined)); };
  
  _.formatISODate      = function(date) {
    return date && !isNaN(date.getTime()) ? "" + this.formatISODateYear(date) + "-" + this.formatISODateMonth(date) + "-" + this.formatISODateDay(date) : "";
  };
  
  _.toISODate = function(value, subst) {
    return (typeof value === "string") && isISODate.test(value)
      ? value
      : (value = this.toDate(value)) && this.formatISODate(value) || subst;
  };  

  $.site.Utils.define(_);
} (jQuery));

(function($) {
  var _ = {};

  _.parseCsvLine = function(line) {
    var result = [];
    var values = line.split(",");
    var inQuotes = false;
    for (var i = 0; i < values.length; i++) {
      var value = values[i];
      if (inQuotes) {
        var trimmed = this.rtrim(value);
        if (trimmed.endsWith('"') && !trimmed.endsWith('\\"')) {
          result.push(inQuotes + trimmed.substring(0, trimmed.length-1));
          inQuotes = false;
        } else {
          inQuotes = inQuotes + value + ",";
        }
      } else {
        var ltrimmed = this.ltrim(value);
        if (ltrimmed.startsWith('"')) {
          var trimmed = this.rtrim(ltrimmed);
          if (trimmed.length > 1 && trimmed.endsWith('"') && !trimmed.endsWith('\\"')) {
            result.push(trimmed.substring(1, trimmed.length-1));
          } else {
            inQuotes = ltrimmed.substring(1) + ",";
          }
        } else {
          result.push(ltrimmed.trim());
        }
      }
    }
    return result;
  };

  _.months = [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ];
  _.weekdays = [ "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday" ];

  _.formatShortDate = function(date) {
    return date && !isNaN(date.getTime()) ? "" + date.getDate() + "-" + this.months[date.getMonth()].substring(0,3) + "-" + date.getFullYear() : "";
  };

  _.formatLongDate = function(date) {
    var suffix;
    switch (date.getDate()) {
      case 1:
      case 21:
      case 31: suffix = "st"; break;
      case 2:
      case 22: suffix = "nd"; break;
      case 3:
      case 23: suffix = "rd"; break;
      default: suffix = "th"; break;
    }
    return this.weekdays[date.getDay()] + " " + date.getDate() + suffix;
  };

  _.formatLongMonth = function(date, year) {
    return this.months[date.getMonth()] + (year ? " " + date.getFullYear() : "");
  };

  _.isSameYear = function(date1, date2) {
    if (!(date1 instanceof Date)) { return false; }
    if (!(date2 instanceof Date)) { return false; }
    if (date1.getYear() !== date2.getYear()) { return false; }
    return true;
  }

  _.isSameMonth = function(date1, date2) {
    if (!this.isSameYear(date1, date2)) { return false; }
    if (date1.getMonth() !== date2.getMonth()) { return false; }
    return true;
  }

  _.isSameDate = function(date1, date2) {
    if (!this.isSameMonth(date1, date2)) { return false; }
    if (date1.getDate() !== date2.getDate()) { return false; }
    return true;
  }

  _.trimAll = function(array) {
    for (var i = 0; i < array.length; i++) {
      array[i] = array[i].trim();
    }
    return array;
  };

  _.ltrim = function(value) {
    var trimmed = (value + ".").trim();
    return trimmed.substring(0, trimmed.length-1);
  };

  _.rtrim = function(value) {
    return ("." + value).trim().substring(1);
  };

  _.forEach = function(callback, thisArg) {
    function breakable(a,b,c) { return callback(a,b,c) !== false; }
    for (var i = 2; i < arguments.length; i++) {
      if (arguments[i] === undefined) { continue; }
      if (! (arguments[i].every(breakable, thisArg)) ) { break; }
    }
  };

  $.site.Utils.define(_);
} (jQuery));


(function($) {
  // Imports
  var Utils = $.site.Utils;

  // GUI
  var GUI = $.site.GUI = function() {};
  var _ = GUI.prototype;

  _.init = function(urls, people, editPanels) {
    this.urls = urls;
    this.people = people;
    $("#background-container, #background-mask-container, #home-container, #building-container").show();
    $("#version").text($.site.version);
    this.appendEditPeopleHTML(editPanels.byName.leaving,  "edit-person-template");
    this.appendEditPeopleHTML(editPanels.byName.arriving, "edit-person-template");
    this.appendEditPeopleHTML(editPanels.byName.guest,    "edit-guest-template");
    // Must do this or first show animation is instant rather than animated
    $("#edit-form #edit-message-row").collapse("hide");
  };

  _.appendEditPeopleHTML = function(panel, templateId) {
    var template = $("#" + templateId)[0];
    var nodes = [];
    this.people.initials.forEach(function(initial) {
      var image = this.people.image[initial];
      var field = panel.name + "-" + initial;
      var $html = $(document.importNode(template.content, true));
      var $container = $html.children();
      var $label = $html.find("label");
      var $input = $html.find("input");
      var $img = $html.find("img");

      $container.attr("id", $container.attr("id").replace("{{Field}}", field));
      $label.attr("for", $label.attr("for").replace("{{Field}}", field));
      $input.attr("id", $input.attr("id").replace("{{Field}}", field));
      $input.attr("name", field);
      $img.attr("src", image);

      nodes.push($html[0]);
    }, this);
    $("#" + panel.id).findTop(".s-edit-question-content").append(nodes);
  };

  _.onListRefresh    = function(handler) { $("#readings-container .s-alert-link").on("click", handler); };
  _.onEditPrev       = function(handler) { $("#edit-prev button").on("click", handler); };
  _.onEditNext       = function(handler) { $("#edit-next button").on("click", handler); };
  _.onEditSubmit     = function(handler) { $("#edit-submit button").on("click", handler); };
  _.onEditDay        = function(handler) { $("#edit-day-container input").on("input", handler); };
  _.onEditNight      = function(handler) { $("#edit-night-container input").on("input", handler); };
  _.onEditStatus     = function(handler) { $("#toolbar-container .s-status-link").on("click", handler) };
  _.onEditDelete     = function(handler) { $("#toolbar-container .s-delete-link").on("click", handler); };
  _.onPopupConfirm   = function(handler) { $("#popupConfirm").on("click", handler); };
  _.onPopupCancel    = function(handler) { $("#popupCancel").on("click", handler); };
  _.onPopupDismiss   = function(handler) { $("#popup").on("hide.bs.modal", handler); };

  function getController(elem) {
    return $("#" + $(elem).attr("aria-controller"));
  }
  function onCollapsing() {
    getController(this).addClass("detail-collapsing");
  }
  function onCollapsed() {
    getController(this).removeClass("detail-collapsing");
  }
  _.onDetailRowCollapsing = function($detailRow) {
    $detailRow.on("show.bs.collapse hide.bs.collapse",    onCollapsing)
              .on("shown.bs.collapse hidden.bs.collapse", onCollapsed);
  };

  _.editToggleInvalidSubmit = function(enabled) {
    $("#edit-submit button").removeClass((enabled ? "btn-submit" : "btn-danger")).addClass((enabled ? "btn-danger" : "btn-submit"));
    $("#edit-form #edit-message-row").collapse((enabled ? "show" : "hide"));
  };

  _.editShowDayNightDiff = function(name) {
    var $el = $("#edit-" + name);
    var val = parseInt($el.val());
    var min = Utils.toInt($el.attr("min"), 0);
    var diff = isNaN(val) ? 0 : val - min;
    var txt = "" + diff == 0 ? "" : (diff > 0 ? "+" : "") + diff;
    $("#edit-" + name + "-container .s-edit-daynight-diff").text(txt);
  };

  _.$alertContainer = function() { return $("#readings-container .s-alert-container"); };

  _.listShowRefresh = function(page) {
    var $alert = this.$alertContainer();
    if ($alert.filter(".show").get().length == 0) { $alert.collapse("show"); }
    $alert.find(".s-alert-link").attr("href", "#" + page.building.toLowerCase());
  };

  _.listHideRefresh = function() {
    this.$alertContainer().collapse("hide");
  };

  _.showBackground = function(page) {
    $("#background-container")
      .removeClass("s-background-cottage s-background-barn s-background-no-color d-none")
      .addClass("s-background-" + page.building.toLowerCase());
    $("#background-mask-container").addClass("d-none");
  };

  _.showHome = function(page) {
    this.showBackground(page);
    $("#home-container").removeClass("d-none");
    $("#building-container").addClass("d-none");
    $("#background-container").addClass("s-background-no-color");
    $("#background-mask-container").removeClass("d-none");
  };

  _.showToolbar = function(page) {
    var title;
    if (page.pageType === "add") {
      title = "Add Reading";
    } else if (page.pageType === "edit") {
      title = "Edit Reading";
    } else {
      title = "Readings";
    }

    var showAdd, showDone, showHome, dark, heading;
    if (page.pageType === "add" ||
        page.pageType === "edit") {
      showAdd = false;
      showDone = true;
      showHome = false;
      dark = true;
      heading = false;
    } else {
      showAdd = true;
      showDone = false;
      showHome = true;
      dark = false;
      heading = true;
    }

    var $toolbar = $("#toolbar-container");
    $toolbar.find(".s-toolbar-title").text(title);
    $toolbar.find(".s-toolbar-building").text(page.building);
    $toolbar.find(".s-add-link").toggleClass("d-none", !showAdd);
    $toolbar.find(".s-done-link").toggleClass("d-none", !showDone);
    $toolbar.find(".s-home-link").toggleClass("d-none", !showHome);
    $toolbar.find(".s-delete-link").addClass("d-none");
    $toolbar.find(".s-delete-link").addClass("d-none");
    $toolbar.find(".s-toolbar-status-icons").addClass("d-none");
    $toolbar.find(".s-toolbar-icon").addClass("d-none");
    $toolbar.toggleClass("s-toolbar-highlight", dark);

    $("#heading-container").collapse((heading ? "show" : "hide"));
    $("#nav-container").toggleClass("no-heading", !heading);
  };

  _.showContent = function(page) {
    // Add/Edit reading
    if (page.pageType === "add" ||
        page.pageType === "edit") {

      $("#readings-more-spacer").addClass("d-none");
      $("#readings-container").addClass("d-none");
      $("#edit-container").removeClass("d-none");
      $("#edit-container .s-edit-question").addClass("d-none");
      $("#edit-prev").addClass("d-none");
      $("#edit-next").addClass("d-none");

    // List readings
    } else {
      $("#readings-container").removeClass("d-none");
      $("#edit-container").addClass("d-none");
      this.listHideRefresh();
    }
  };

  _.focusTop = function() {
    $(document.activeElement).trigger("blur");
  };

  _.focusPrevNextButton = function(direction) {
    var $button = direction > 0 ? $("#edit-next button") : $("#edit-prev button");
    $button.trigger("focus");
  };

  _.showQuestion = function(page) {
    var $questions = $("#edit-container .s-edit-question");
    var $question = $("#" + (page.panel && page.panel.id));
    $questions.addClass("d-none");
    $question.removeClass("d-none");

    $("#edit-title").text($question.attr("data-title"));

    // Reset
    $("#edit-prev, #edit-next").removeClass("d-none");
    $("#edit-prev button, #edit-next button").removeClass("btn-primary btn-secondary btn-success btn-danger");

    // Submit button
    $("#edit-submit").toggleClass("d-none", !page.isSubmitNext);

    // Prev button
    $("#edit-prev button").addClass("btn-secondary")
                          .text((page.prevPanel && page.prevPanel.buttonName) || "◀︎")
                          .toggleClass("disabled", !page.prevPanel);

    // Next button
    $("#edit-next button").addClass("btn-primary")
                          .text((page.nextPanel && page.nextPanel.buttonName) || "▶︎")
                          .toggleClass("disabled", !page.nextPanel);

    // Delete
    $("#toolbar-container .s-delete-link").toggleClass("d-none", page.pageType !== "edit");

    // Error message
    $("#edit-message").text(page.error);
    var $message = $("#edit-form #edit-message-row");
    if (page.error) {
      $message.collapse("show");
    } else {
      $message.removeClass("show"); // Collapse without animation
    }
  };

  _.showPage = function(page) {
    if (page.pageType === "home") {
      this.showHome(page);
      return;
    }

    $("#home-container").addClass("d-none");
    $("#building-container").removeClass("d-none s-building-barn s-building-cottage").addClass("s-building-" + page.building.toLowerCase());

    this.showToolbar(page);
    this.showContent(page);
    this.showBuilding(page);

    this.dismissPopup();
  };

  _.showBuilding = function(page) {
    this.showBackground(page);
    var buildingId = page.building.toLowerCase();
    var $navElem = $("#nav-container");
    $navElem.find(".s-home-link").attr("href", "#home/" + buildingId);
    $navElem.find(".s-add-link").attr("href", "#" + buildingId + "/add");
    $navElem.find(".s-done-link").attr("href", "#" + buildingId);
    $navElem.find(".s-building-name").text(page.building);
    $navElem.find(".s-building-initial").text(page.building.substring(0,1));
    $navElem.find(".s-building-initial-after").text(page.building.substring(1));
    $navElem.find(".s-building-link").attr("href", "#" + (page.pageType === 'list' ? "" : buildingId));
  };

  _.showReading = function($parent, reading) {
    var dayDigitElems = $parent.find(".s-reading-day .s-reading-digit");
    var nightDigitElems = $parent.find(".s-reading-night .s-reading-digit");

    // No readings
    if (!reading) {
      dayDigitElems.html("&nbsp;");
      nightDigitElems.html("&nbsp;");

    // Readings
    } else {
      this.appendDigits(dayDigitElems, reading.day);
      this.appendDigits(nightDigitElems, reading.night);
    }
  };

  _.appendDigits = function(digitElems, amount) {
    for (var i = digitElems.length-1; i >= 0; i--) {
      var nextAmount = Math.floor(amount / 10);
      var digit = nextAmount === 0 ? amount : amount % (nextAmount * 10);
      amount = nextAmount;
      $(digitElems[i]).text(digit);
    }
  };

  _.$popup = function() {
    return $("#popup");
  };

  _.showPopup = function(name) {
    var title, message, noDismiss, cancel, ok, status;
    if (name === "wait") {
      title = "Saving...";
      message = "Please wait, your changes are being saved.";
      status = name;
      noDismiss = true;
      cancel = "Cancel";
      ok = false;
    } else if (name === "ok") {
      title = "Saved";
      message = "Your changes have been saved.";
      status = name;
      cancel = "Close";
      ok = false;
    } else if (name === "error") {
      title = "Save Failed";
      message = "There was a problem saving your changes.";
      status = name;
      noDismiss = true;
      cancel = "Cancel";
      ok = "Retry";
    } else if (name === "fatal") {
      title = "Internal Error";
      message = "Sorry, something got corrupted. You'll need to start again.";
      status = name;
      noDismiss = false;
      cancel = "Close";
      ok = false;
    } else if (name === "cancel") {
      title = "Confirm Cancel";
      message = "Are you sure you want to discard your changes?";
      cancel = "Keep Changes";
      ok = "Discard";
      noDismiss = true;
    } else if (name === "delete") {
      title = "Delete Reading";
      message = "Are you sure you want to delete this reading?";
      cancel = "Cancel";
      ok = "Delete";
    }

    // Title, message, buttons
    $("#popupLongTitle").text(title);
    $("#popupBody").toggle(!!message).html(message);
    $("#popupClose").toggle(!noDismiss);
    this.togglePopupCancel(cancel);
    this.togglePopupOK(ok);

    // Status
    var $popupStatus = $("#popupStatus");
    $popupStatus.toggle(!!status);
    if (status) {
      $popupStatus
        .find(".s-status-icon")
        .removeClass("s-status-wait s-status-ok s-status-error s-status-fatal")
        .addClass("s-status-" + name)
        .toggleClass("animated flash infinite", (name === "wait"));
    }

    var $popup = this.$popup();
    var oldData = $popup.data("bs.modal");
    var isShown = false;

    // No Dismiss
    if (oldData) {
      isShown = oldData._isShown;
      oldData._config.backdrop = (noDismiss ? "static" : true);
      oldData._config.keyboard = (!noDismiss);
    }

    // Show
    if (!isShown) {
      var showOptions = noDismiss ? { backdrop: "static", keyboard: false } : "show";
      var popup = Modal.getOrCreateInstance($popup[0], showOptions);
      popup.show();
    }
  };

  _.dismissPopup = function() {
    var popup = Modal.getInstance(this.$popup()[0]);
    if (popup) { popup.hide(); }
  };

  _.togglePopupCancel = function(title, enabled) {
    this.togglePopupButton("popupCancel", title, enabled);
  };

  _.togglePopupOK = function(title, enabled) {
    this.togglePopupButton("popupConfirm", title, enabled);
  };

  _.togglePopupButton = function(id, title, enabled) {
    $("#" + id).toggle(title !== false).text(title).prop("disabled", (enabled === false));
  };
} (jQuery));

//=require utils-convert.js

(function($) {
  var Properties = $.site.Properties = function() {
    this.descriptors = {};
    this.initialised = false;
  };  
  var _ = Properties.prototype;

  _.define = function(target) {
    Object.defineProperties(target, this.descriptors);

    if (!this.initialised) {
      this.initialised = true;
      Object.defineProperties(Object.getPrototypeOf(target), this.descriptors);
    }    
  };
  
  _.add = function(name, validator, defaultValue) {
    if (validator) {
      this.addAccessor(name, validator, defaultValue);
    } else {
      this.descriptors[name] = { enumerable: true, writable: true, value: defaultValue };
    }
  };
  
  _.addAccessor = function(name, validator, defaultValue) {
    var validatorWithDefault = validator;
    if (defaultValue !== undefined) {
      validatorWithDefault = function(value) {
        value = validator ? validator(value) : value;
        return value !== undefined && value !== null ? value : (typeof defaultValue === "function" ? defaultValue() : defaultValue);
      };
    }
    var iVar = "_" + name;
    this.descriptors[iVar] = { value: defaultValue, writable: true };
    this.descriptors[name] = { enumerable: true,
      get: function() { return this[iVar]; },
      set: function(value) { this[iVar] = validatorWithDefault ? validatorWithDefault(value) : value; },
      validator: validator,
      defaultValue: defaultValue
    };
  };

  _.addConst = function(name, instantiator) {
    this.descriptors[name] = { enumerable: true, configurable: true,
      get: function() {
        var value = instantiator.call(this);
        Object.defineProperty(this, name, { enumerable: true, value: value });
        return value;
      }
    };
  };
  
  _.addComputed = function(name, getter) {
    this.descriptors[name] = { enumerable: true, get: getter };
  };
  
} (jQuery));
//=require ../../../src/js/singleton.js
//=require _utils.js

(function($) {
  // Imports
  var Utils = $.site.Utils;
  var Singleton = $.site.Singleton;
  var Properties = $.site.Properties;

  // Globals
  var People = $.site.People = new Singleton({ initials: [], image: {} });


  // Readings
  var Readings = $.site.ReadingsClass = (function() {

    function Readings(isBarn) {
      this.properties.define(this);

      this.isBarn = !!isBarn;
    }
    var _ = Readings.prototype;

    _.properties = new Properties();
    _.properties.add     ("isBarn",  Utils.toBool);
    _.properties.addConst("list",    function() { return []; });
    _.properties.addConst("deleted", function() { return []; });
    _.properties.addComputed("building", function() { return this.isBarn ? "Barn" : "Cottage"; });

    _.toJSONId = function() {
      return { building: this.building, list: this.list.length, deleted: this.deleted.length };
    };

    _.toJSON = function() {
      return {
        building: this.building,
        list: this.list.map(function(reading) { return reading.when; }),
        deleted: this.deleted.map(function(reading) { return reading.when; })
      };
    };

    return Readings;

  })();


  // Reading
  var Reading = $.site.Reading = (function() {

    function Reading(identifier, when, day, night, isEmpty, timestamp, dayRate, nightRate) {
      this.properties.define(this);

      this.identifier = identifier;
      this.when = when;
      this.day = day;
      this.night = night;
      this.isEmpty = isEmpty;
      this.timestamp = timestamp;
      this.dayRate = dayRate;
      this.nightRate = nightRate;
    }
    var _ = Reading.prototype;

    _.properties = new Properties();
    _.properties.add("readings",   undefined);
    _.properties.add("index",      Utils.toInt);
    _.properties.add("identifier", undefined);
    _.properties.add("when",       Utils.toISODate);
    _.properties.add("day",        Utils.toInt);
    _.properties.add("night",      Utils.toInt);
    _.properties.add("isEmpty",    Utils.toBool);
    _.properties.add("timestamp",  Utils.toInt);
    _.properties.add("dayRate",    Utils.toFloat);
    _.properties.add("nightRate",  Utils.toFloat);
    _.properties.add("isCorrupt",  Utils.toBool);
    _.properties.addComputed("isBarn",   function() { return this.readings.isBarn; });
    _.properties.addComputed("building", function() { return this.readings.building; });
    _.properties.addComputed("whenDate", function() { return Utils.toDate(this.when); });
    _.properties.addComputed("previous", function() { return this.readings.list[this.index + 1]; });
    _.properties.addComputed("next",     function() { return this.readings.list[this.index - 1]; });

    _.isSameDate  = function(reading) { return !!(reading && Utils.isSameDate (this.whenDate, reading.whenDate)); };
    _.isSameMonth = function(reading) { return !!(reading && Utils.isSameMonth(this.whenDate, reading.whenDate)); };
    _.isSameYear  = function(reading) { return !!(reading && Utils.isSameYear (this.whenDate, reading.whenDate)); };

    _.toJSONId = function() {
      return this.when;
    };

    _.toJSON = function() {
      var result = Object.assign({}, this);
      if (result.previous) { result.previous = this.previous.toJSONId(); }
      if (result.next)     { result.next     = this.next.toJSONId(); }
      if (result.readings) { result.readings = this.readings.toJSONId(); }
      return result;
    };

    _.toString = function() { return JSON.stringify(this,undefined," "); };

    return Reading;

  })();


  // People
  // Note: Reading must already be defined
  (function() {

    var _ = {};

    _.init = function(people) {
      for (var i = 0; i < people.length; i++) {
        var person = people[i];
        var initial = person.initial;
        this.initials.push(initial);
        this.image[initial] = person.image;

        // Configure Reading class
        Reading.prototype.properties.add(initial, Utils.toInt);
      }
    };

    People.define(_);

  })();


  // Stays
  var Stay = $.site.Stay = (function() {

    function Stay(startReading, endReading, stayers) {
      this.properties.define(this);

      this.startReading = startReading;
      this.endReading = endReading;
      this.stayers = stayers;
    }
    var _ = Stay.prototype;

    _.properties = new Properties();
    _.properties.addComputed("dayRate", function() { return this.startReading.dayRate; });
    _.properties.addComputed("nightRate", function() { return this.startReading.isEmpty ? 0 : this.startReading.nightRate; });
    _.properties.addComputed("dayUsed", function() { return !this.endReading ? 0 : this.endReading.day - this.startReading.day; });
    _.properties.addComputed("nightUsed", function() { return !this.endReading ? 0 : this.endReading.night - this.startReading.night; });
    _.properties.addComputed("cost", function() { return ((this.dayUsed * this.dayRate) + (this.nightUsed * this.nightRate)) / 100; });
    _.properties.addComputed("days", function() { return !this.endReading ? 0 : Math.round((this.endReading.whenDate - this.startReading.whenDate) / 1000 / 60 / 60 / 24); });

    _.isSameDate  = function(stay) { return this.startReading.isSameDate(stay && stay.startReading); };
    _.isSameMonth = function(stay) { return this.startReading.isSameMonth(stay && stay.startReading); };
    _.isSameYear  = function(stay) { return this.startReading.isSameYear(stay && stay.startReading); };

    _.toJSON = function() {
      return {
        when: this.startReading.when,
        stayers: this.stayers,
        cost: this.cost,
        days: this.days
      };
    };

    return Stay;

  })();


  // ReadingsManager
  $.site.Readings = new Singleton((function() {

    var _ = {};

    _.parseCsv = function(csv, target) {
      var lines = csv.split("\n");
      var headerRow = Utils.parseCsvLine(lines[0]);
      var cols = {};
      for (var i = 0; i < headerRow.length; i++) { cols[headerRow[i]] = i; }
      var idCol = cols["Identifier"];
      var whereCol = cols["Where"];
      var whenCol = cols["Date"];
      var dayCol = cols["Day"];
      var nightCol = cols["Night"];
      var emptyCol = cols["Empty"];
      var timestampCol = cols["Modified"];
      var dayRateCol = cols["DayRate"];
      var nightRateCol = cols["NightRate"];
      var isDeletedCol = cols["Hide"];

      var peopleCols = [];
      People.initials.forEach(function(initial) { peopleCols.push(cols[initial.toUpperCase()]); });

      var cottage = target.cottage = new Readings(false);
      var barn = target.barn = new Readings(true);
      for (var i = 1; i < lines.length; i++) {
        var row = Utils.parseCsvLine(lines[i]);
        var reading = new Reading(
          row[idCol],
          row[whenCol],
          row[dayCol],
          row[nightCol],
          (row[emptyCol] === "Y"),
          row[timestampCol],
          row[dayRateCol],
          row[nightRateCol]
        );
        People.initials.forEach(function(initial, j) { reading[initial] = row[peopleCols[j]]; });

        var isBarn = (row[whereCol] === "Barn");
        var isDeleted = (row[isDeletedCol] === "Y");
        var readings = isBarn ? barn : cottage;
        var list = isDeleted ? readings.deleted : readings.list;
        reading.readings = readings;
        reading.index = list.length;
        list.push(reading);
      }

      // Stays
      target.stays.cottage = this.createStays(cottage.list);
      target.stays.barn = this.createStays(barn.list);
    };

    _.createStays = function(readings) {
      var result = [];
      var order = [];
      var isStaying = {};
      var hasStaying = false;

      // Add a stay if period was a stay, rather than an empty gap between stays
      var didFinishPeriod = (function(reading1, reading2) {
        if (hasStaying) {
          var stay = new Stay(reading1 || reading2, reading2, this.createStayers(isStaying, order));
          var previousStay = result[result.length-1];
          if (previousStay &&
              previousStay.endReading == stay.startReading) { previousStay.chained = true; }
          result.push(stay);
          hasStaying = false;
          order = stay.stayers;
        }
      }).bind(this);

      // Oldest to newest
      for (var i = readings.length - 1; i >= 0; i--) {
        var reading = readings[i];

        // Detect corrupt data
        People.initials.forEach(function(initial) {
          if (isStaying[initial]) {
            // Was previously staying but not now arriving/departing
            if (reading[initial] === undefined) { reading.isCorrupt = true; }
          } else {
            // Was not previously staying but now departing
            if (reading[initial] === 0) { reading.isCorrupt = true; }
          }
        });

        // Maybe add a stay
        didFinishPeriod(readings[i+1], reading);

        // Get new isStaying
        People.initials.forEach(function(initial) {
          if (reading[initial] > 0) {
            isStaying[initial] = true;
            hasStaying = true;
          }
        });

        // Reading has no people at all - ensure it doesn't just disappear
        if (!hasStaying &&
            !People.initials.some(function(initial) { return reading[initial] >= 0; })) {
          hasStaying = true;
        }
      }

      // Latest reading may be an unfinished stay
      didFinishPeriod(readings[0], undefined);

      // Newest to oldest
      result.reverse();
      return result;
    };

    _.createStayers = function(isStaying, order) {
      var stayers = [];
      this.populateStayersWithInitials(          order, stayers, isStaying);
      this.populateStayersWithInitials(People.initials, stayers, isStaying);
      return stayers;
    };

    _.populateStayersWithInitials = function(initials, stayers, isStaying) {
      initials.forEach(function(initial) {
        if (isStaying[initial]) {
          stayers.push(initial);
          isStaying[initial] = false;
        }
      });
    };

    return _;

  })());
} (jQuery));

//=require site-blank.js

(function($) {
  // GoogleSubmit
  var GoogleSubmit = $.site.GoogleSubmit = function() {};
  var _ = GoogleSubmit.prototype;
  
  _.init = function(form, url) {
    if (url) {
      form.$().attr("action", url);
    }
  };
  
  _.submit = function(form) {
    return new Promise(function(resolve, reject) {
      var frameId = '__submit__' + form.$().attr('id') + '__' + Date.now();
      var $iframe = $('<iframe>');
      var iframe = $iframe[0];
      
      function onload() {
        $(iframe).remove();
        resolve();
      }
      
      function onerror(e) {
        $(iframe).remove();
        reject(e);
      }
      
      var started = false;
      function start() {
        if (started) { return; }
        started = true;
        
        var $iframe = $(iframe);
        $iframe.off('load', start)
          .off('error', start)
          .on('load', onload)
          .on('error', onerror);
    
        var $form = form.$();
        $form.attr('target', frameId);
        $form.submit();
      }
      
      $iframe.attr('id', frameId);
      $iframe.attr('name', frameId);
      $iframe.on('load', start).on('error', start);
      $(document.body).append($iframe);
    });
  };
} (jQuery));
//=require form.js

(function($) {
  var _;
  var Form = $.site.Form;
  
  // FormStore
  var FormStore = $.site.FormStore = function(form) {
    this.form = form;
    this.data = {};
  };
  _ = FormStore.prototype;
  
  _.init = function() {
    var storeKey = this.getStoreKey();
    var loaded = sessionStorage.getItem(storeKey);
    if (loaded) {
      try {
        this.data = JSON.parse(loaded) || {};
        this.load();
      } catch (e) {
        console.log("[FormStore::error] " + e + "\n" + loaded);
      }
    }
  };
  
  _.isEmpty = function() { return !this.data.fields; };
  _.getStoreKey = function() { return "forms::" + this.form.id; };
  
  _.remove = function() {
    sessionStorage.removeItem(this.getStoreKey());
    this.data = {};
  };
  
  _.load = function() {
    this.form.write(this.data.fields);
  };
  
  _.save = function(options) {
    this.form.read();
    var data = this.data = {fields: this.form.fields};
    if (options) { Object.assign(data, options); }
    var storeKey = this.getStoreKey();
    sessionStorage.setItem(storeKey, JSON.stringify(data));
  };

  _.toString = function() {
    return ""
      + "[#" + this.form.id + "::store]\n" + Form.stringify(this.data) + "\n"
      + "[#" + this.form.id + "::html]\n"  + Form.stringify(this.form.fields);
  };
} (jQuery));
//=require ../../../src/js/properties.js
//=require properties.js

(function($) {
  var Properties = $.site.Properties;

  function defineCleanSourceDynamicClass(keys) {
    function SourceProvider(dirty, cleanInstanceProperty) {
      this.dirty = dirty;
      this.cleanInstanceProperty = cleanInstanceProperty;
    }
    var _ = SourceProvider.prototype;
    Object.defineProperty(_, "clean", { enumerable: true,
      get: function() { return this.dirty[this.cleanInstanceProperty]; }
    });
    _.reset = function() {
      keys.forEach(function(key) {
        this.dirty[key] = undefined;
      }, this);
    };
    return SourceProvider;
  }
  
  function defineCleanSourceStaticClass(keys, maskProperties) {
    function Source(dirty, cleanInstanceProperty) {
      this.properties.define(this);
      Object.defineProperty(this, cleanInstanceProperty, {
        get: function() { return dirty[cleanInstanceProperty]; }
      });
    }
    Source.prototype.properties = maskProperties;
    
    function SourceProvider(dirty, cleanInstanceProperty) {
      this.dirty = dirty;
      this.clean = new Source(dirty, cleanInstanceProperty);
    }
    var _ = SourceProvider.prototype;
    _.reset = function() {
      keys.forEach(function(key) {
        this.clean[key] = this.dirty[key];
      }, this);
    };
    SourceProvider.newSnapshot = function() { return new Source(); };
    return SourceProvider;
  }
  
  function defineDirtyPropertiesClass(keys) {
    function isDirtyProperty(clean, dirty, key) {
      var cleanVal = clean && clean[key];
      var dirtyVal = dirty[key];
  
      if (cleanVal == dirtyVal) { return false; }
      if (dirtyVal === undefined) { return false; }
      if (typeof cleanVal === "object" &&
          typeof dirtyVal === "object" &&
          // For dates, this compares times, which doesn't happen automatically with the == operator, sadly
          cleanVal.valueOf() == dirtyVal.valueOf()) { return false; }
      return true;
    }
  
    function DirtyProperties(source) {
      this.properties.define(this);
      
      this._source = source;
    }
    var _ = DirtyProperties.prototype;
    
    _.properties = new Properties();
    
    _.properties.descriptors["_source"] = { writable: true };
    
    for (var i = 0; i < keys.length; i++) {
      // Note: must wrap in a function, because otherwise all defined getter functions
      // capture same loop variable (i.e. properties[i]).
      (function(key) {
        _.properties.addComputed(key,
          function() {
            return isDirtyProperty(this._source.clean, this._source.dirty, key);
          }
        );
      })(keys[i]);
    }

    _.toJSON = function() { return keys.filter(function(key) { return this[key]; }, this); };
    
    return DirtyProperties;
  }

  function defineDirtyProperties(dirtyProperties, cleanInstanceProperty, cleanProperties) {
    var keys = [];
    
    var maskProperties = new Properties();
    var descriptors = cleanProperties.descriptors;
    for (var key in descriptors) {
      if (key === cleanInstanceProperty) { continue; }
      
      var descriptor = descriptors[key];
      if (!descriptor.enumerable) { continue; }
      if (! (descriptor.writable || descriptor.set)) {
//         (function(key) {
//           maskProperties.addComputed(key, function() { return this[cleanInstanceProperty] ? this[cleanInstanceProperty][key] : undefined; });
//         })(key);
        continue;
      }
      
      keys.push(key);
      
      maskProperties.addAccessor(key, descriptor.validator);
      var maskDescriptor = maskProperties.descriptors[key];
      
      // Override getter so automatically gets value from clean source if value not explicitly set
      maskDescriptor.get = (function(key, oldGet) {
        return function() {
          var dirtyResult = oldGet.call(this);
          return dirtyResult !== undefined ? dirtyResult : (this[cleanInstanceProperty] ? this[cleanInstanceProperty][key] : undefined);
        };
      })(key, maskDescriptor.get);
    }
    
    Object.assign(dirtyProperties.descriptors, maskProperties.descriptors);
    
    var DirtyProperties = defineDirtyPropertiesClass(keys);
    var CleanSourceDynamic = defineCleanSourceDynamicClass(keys);
    var CleanSourceStatic = defineCleanSourceStaticClass(keys, maskProperties);
    
    function DirtyIsAre(source) {
      this.is = new DirtyProperties(source);
    }
    var _ = DirtyIsAre.prototype;
    Object.defineProperty(_, "are", { enumerable: true,
      get: function() {
        return keys.filter(function(key) { return this.is[key]; }, this);
      }
    });
    _.getCleanValue = function(key) { return this.is._source.clean ? this.is._source.clean[key] : undefined; };
    _.getDirtyValue = function(key) { return this.is._source.dirty[key]; };
    _.snapshot = function() {
      var result = CleanSourceStatic.newSnapshot();
      keys.forEach(function(key) {
        var value = this.getDirtyValue(key);
        if (value === undefined) { value = this.getCleanValue(key); }
        result[key] = value;
      }, this);
      return result;
    };
    _.toJSON = function() { return this.are; };
    
    function Dirty(owner) {
      this.all = new DirtyIsAre(new CleanSourceDynamic(owner, cleanInstanceProperty));
      this.uncommitted = new DirtyIsAre(new CleanSourceStatic(owner, cleanInstanceProperty));
    }
    _ = Dirty.prototype;
    _.properties = new Properties();
    
    Object.defineProperty(_, "can", { enumerable: true, writable: false, value: keys });
    _.clean = function() {
      this.all.is._source.reset();
      this.uncommitted.is._source.reset();
    };
    _.commit = function() {
      this.uncommitted.is._source.reset();
    };

    dirtyProperties.addConst("dirty", function() { return new Dirty(this); });
  }

  $.site.Dirty = {
    defineDirtyProperties: defineDirtyProperties
  };
} (jQuery));
//=require _reading.js
//=require _utils.js

(function($) {
  // Imports
  var Utils = $.site.Utils;
  var Properties = $.site.Properties;
  var Dirty = $.site.Dirty;
  var Reading = $.site.Reading;
  var People = $.site.People;
  var Form = $.site.Form;
  var FormStore = $.site.FormStore;
  var GoogleSubmit = $.site.GoogleSubmit;

  // Globals
  var _;
  var PeopleBool = function() { this.properties.define(this); };
  var PeopleInt = function() { this.properties.define(this); };
  PeopleBool.prototype.properties = new Properties();
  PeopleInt.prototype.properties = new Properties();

  // GoogleFields
  var GoogleFields = function() {
    this.idToName = {};
    this.nameToId = {};
  };
  _ = GoogleFields.prototype;

  _.init = function(form) {
    var idToName = this.idToName;
    var nameToId = this.nameToId;
    form.$().find("input").each(function() {
      var $this = $(this);
      var id = $this.attr("id").substring("g-".length);
      var name = $this.attr("name");
      idToName[id] = name;
      nameToId[name] = id;
    });
  };

  _.getFieldNameForName = function(name) { return this.idToName[name]; };
  _.getNameForFieldName = function(name) { return this.nameToId[name]; };


  // EditReading
  var EditReading = $.site.EditReading = function(reading) {
    Reading.prototype.constructor.call(this); // Inheritance
    this.properties.define(this);

    this.reading = reading;
    this.validate();
  };
  EditReading.prototype = Object.create(Reading.prototype); // Inheritance
  EditReading.prototype.constructor = EditReading; // Inheritance
  _ = EditReading.prototype;

  _.properties = new Properties();

  EditReading.init = function() {
    Dirty.defineDirtyProperties(EditReading.prototype.properties, "reading", Reading.prototype.properties);
  };

  _.reset = function() {
    this.dirty.clean();
    this.validate();
  };

  _.validate = function() {
    var oldOccupants = this.oldOccupants = {};
    if (this.previous) {
      People.initials.forEach(function(initial) {
        var count = this.previous[initial];
        if (count) { this.oldOccupants[initial] = count; }
      }, this);
    }

    var newOccupants = this.newOccupants = {};
    var leaving = this.leaving = [];
    var arriving = this.arriving = [];
    People.initials.forEach(function(initial) {
      var oldCount = oldOccupants[initial];
      var newCount = this[initial];

      // Invalid new count - remove (possible) mask value and check again.
      if (newCount === 0 && !(oldCount > 0)) {
        this[initial] = undefined; // Remove masking value (if exists)
        newCount = this[initial];

        // Clean (i.e. saved) value is:
        // - Invalid if === 0
        // - Valid if > 0 and we're intentionally trying to change it to 0.
        if (newCount >= 0) {
          // Must use a number so that it masks the underlying "clean" value, because
          // undefined/null gets ignored
          this[initial] = -1;
        }
      }

      // Person is arriving, or else continuing to stay
      if (newCount > 0) {
        newOccupants[initial] = newCount;

      // Person is neither arriving or leaving
      } else if (newCount === undefined) {

        // Person was already staying
        if (oldCount) {

          // Adding new reading - assume person is leaving by default
          if (! (this.reading && this.reading.identifier)) {
            newCount = 0;

          // Editing existing reading - respect previously-saved setting
          } else {
            newCount = oldCount;
          }

          newOccupants[initial] = newCount;
        }
      }

      // Commit arriving/leaving status
      if (newCount > 0) {
        if (!oldCount) { arriving.push(initial); }
      } else if (oldCount) {
        leaving.push(initial);
      }
    }, this);

    this.validateDayNight("day");
    this.validateDayNight("night");
  };

  _.validateDayNight = function(name, force) {
    if (!this.previous) { return; }
    if (this[name] !== undefined && this[name] < this.previous[name]) {
      this[name] = undefined; // Try to restore default
    }
    if (force && this[name] === undefined) { this[name] = this.previous[name]; }
  };

  _.validateForSubmit = function() {
    this.validateDayNight("day", true);
    this.validateDayNight("night", true);
  };



  // Mapping
  var Mapping = function() { this.defs = {}; };
  _ = Mapping.prototype;

  _.add = function(name, sources, map) {
    if (!Array.isArray(sources)) { sources = [sources]; }
    this.defs[name] = { name:name, sources:sources, map:map };
  };

  _.sources = function(sourceObj, name) {
    var def = this.defs[name];
    return !def ? [] : def.sources.map(function(path) {
      var parts = path.split('.');
      var lastKey = parts.pop();

      var parent = sourceObj;
      parts.forEach(function(k) {
        parent = parent[k];
      });
      return {object:parent, key:lastKey, path:path};
    });
  };

  _.serializeArray = function(sourceObj, target) {
    var result = [];
    for (var key in this.defs) {
      var def = this.defs[key];
      var sourceValues = this.sources(sourceObj, def.name).map(function(source) {
        return source.object[source.key];
      });
      var value = def.map ? def.map.apply(target, sourceValues) : (sourceValues.length > 1 ? sourceValues : sourceValues[0]);
      result.push({name:def.name, value:value});
    }
    return result;
  };



  // EditFormParser
  var EditFormParser = function() {
    this.properties.define(this);

    this.arriving = new PeopleBool();
    this.leaving = new PeopleBool();
    this.guests = new PeopleInt();
  };
  _ = EditFormParser.prototype;

  EditFormParser.init = function() {
    var fieldMappings = (function() {
      function toChecked(v) { return v ? "1" : (v !== undefined ? "" : undefined); }

      var m = new Mapping();
      m.add( "when-year",  "year", Utils.formatYear);
      m.add("when-month", "month", Utils.formatMonth);
      m.add( "when-date",  "date", Utils.formatDay);
      m.add(     "empty", "empty", Utils.toString);
      m.add(       "day",   "day");
      m.add(     "night", "night");
      People.initials.forEach(function(initial) {
        m.add( "arriving-" + initial, "arriving." + initial, toChecked);
        m.add(  "leaving-" + initial,  "leaving." + initial, toChecked);
        m.add(    "guest-" + initial,   "guests." + initial);
      });
      return m;
    })();

    var readingMappings = (function() {
      var m = new Mapping();
      m.add("when", ["year","month","date"], function(year, month, date) {
        if (year === undefined && month === undefined && date === undefined) {
          return undefined;
        } else {
          return Utils.toDateWithComponents(year, month, date, (this.reading || this).whenDate || new Date());
        }
      });
      m.add("isEmpty", "empty");
      m.add(    "day",   "day");
      m.add(  "night", "night");
      People.initials.forEach(function(initial) {
        m.add(initial, ["arriving."+initial, "leaving."+initial, "guests."+initial], function(arriving, leaving, guests) {
          var count = 0;
          if (arriving ||
              (!leaving &&
              this.oldOccupants[initial]))
          {
            count = 1 + (guests || 0);
          }
          return count;
        });
      });
      return m;
    })();

    EditFormParser.mapping = {
      field:   fieldMappings,
      reading: readingMappings
    };
  };

  _.properties = new Properties();

  _.properties.add("year",  Utils.toYear);
  _.properties.add("month", Utils.toMonth);
  _.properties.add("date",  Utils.toDay);
  _.properties.add("empty", Utils.toBool);
  _.properties.add("day",   Utils.toInt);
  _.properties.add("night", Utils.toInt);

  _.toFields = function() {
    return EditFormParser.mapping.field.serializeArray(this);
  };

  _.toReading = function(reading) {
    EditFormParser.mapping.reading.serializeArray(this, reading).forEach(function(field) {
      reading[field.name] = field.value;
    });
    reading.validate();
  };

//   _.isDirtyField = function(field) {
//     var sources = EditFormParser.mapping.field[field].sources;
//     return sources.some(function(source) { return this.dirty[source]; }, this);
//   };

  EditFormParser.withFields = function(fields) {
    var result = new EditFormParser();

    // Set props using fields
    fields.forEach(function(field) {
      EditFormParser.mapping.field.sources(result, field.name).forEach(function(source) {
        source.object[source.key] = field.value;
      });
    });

    // Validate
    People.initials.forEach(function(initial) {
      if (result.leaving[initial] && result.arriving[initial]) { result.arriving[initial] = false; }
      if (result.guests[initial] && result.leaving[initial]) { result.guests[initial] = 0; }
    });

    return result;
  };

  EditFormParser.withReading = function(reading) {
    var result = new EditFormParser();

    // Arriving/leaving
    People.initials.forEach(function(initial) {
      result.leaving[initial] = false;
      result.arriving[initial] = false;
    });
    reading.leaving.forEach(function(initial) {
      result.leaving[initial] = true;
    });
    reading.arriving.forEach(function(initial) {
      result.arriving[initial] = true;
    });

    // Guests
    var initials = Object.keys(reading.newOccupants);
    for (var i = 0; i < initials.length; i++) {
      var initial = initials[i];
      var count = reading.newOccupants[initial];
      if (count > 1) { result.guests[initial] = count - 1; }
    }

    // Others
    result.empty = reading.isEmpty;
    result.day = reading.day;
    result.night = reading.night;

    // Date
    var date = reading.whenDate;
    result.year = date ? date.getFullYear() : undefined;
    result.month = date ? date.getMonth() + 1 : undefined;
    result.date = date ? date.getDate() : undefined;

    // Dirty
//     var dirty = result.dirty = {};
//     reading.dirty.all.are.forEach(function(prop) {
//       var mapping = EditFormParser.mapping.reading[prop];
//       if (mapping) {
//         mapping.sources.forEach(function(source) { dirty[source] = true; });
//       }
//     });

    return result;
  };



  // GFormParser
  var GFormParser = {};

  GFormParser.toReading = function(fields) {
    var reading = new Reading();
    fields.forEach(function(field) {
      var name = field.name;
      var value = field.value;
      if (name === "where") {
        name = "isBarn";
        value = value === "Barn";
      } else if (field.name === "empty") {
        name = "isEmpty";
        value = value === "Y";
      } else if (field.name === "hide") {
        return; // Property not set on reading itself
      } else if (field.name === "when") {
        value = Utils.toDate(value);
      }
      reading[name] = value;
    });
    return reading;
  };

  GFormParser.toFields = function(reading, options) {
    var fields = [];
    fields.push({ name: "when", value: reading.when || "" });
    fields.push({ name: "where", value: reading.isBarn ? "Barn" : "Cottage" });
    fields.push({ name: "identifier", value: (reading.identifier || "") });
    fields.push({ name: "empty", value: (reading.isEmpty ? "Y" : "N") });
    fields.push({ name: "day",   value: reading.day });
    fields.push({ name: "night", value: reading.night });
    fields.push({ name: "hide", value: (options && options.isDelete ? "Y" : "") });

    People.initials.forEach(function(initial) {
      // Value may have been intentionally masked using -1
      var value = reading[initial] >= 0 ? reading[initial] : undefined;
      fields.push({ name: initial, value: value });
    });
    return fields;
  };



  // Edit
  var Edit = $.site.Edit = function(id, gid) {
    this.properties.define(this);

    this.form = new Form(id);
    this.gform = new Form(gid, new GoogleFields(), new GoogleSubmit());
    this.store = new FormStore(this.form);
    this.gstore = new FormStore(this.gform);
  }
  _ = Edit.prototype;

  _.properties = new Properties();

  _.init = function(config) {
    People.initials.forEach(function(initial) {
      PeopleBool.prototype.properties.add(initial, Utils.toBool);
       PeopleInt.prototype.properties.add(initial, Utils.toInt);
    });
    EditReading.init();
    EditFormParser.init();

    this.form.init(); // Read form fields
    this.gform.init(config.urls.submit); // Read form fields
    this.store.init(); // Load saved fields
    this.gstore.init(); // Load saved fields
    if (!this.store.isEmpty()) { this.store.load(); }
    if (!this.gstore.isEmpty()) {
      this.gstore.load();
      this.pending = Object.assign({reading: GFormParser.toReading(this.gstore.data.fields)}, this.gstore.data);
      delete this.pending.fields;
    }
//     this.log("[edit::init]");
  };

  _.reset = function(remove, removeGstore) {
    this.form.reset();
    this.gform.reset();
    if (remove) {
      this.store.remove();
      this.pageId = undefined;
    }
    if (removeGstore) {
      this.confirm();
    }
  };

  _.read = function(reading, load) {
    // Get form input values
    if (load) {
      this.store.load();
      this.pageId = this.store.data.pageId;
    } else {
      this.form.read();
    }

    // this.log("[edit::read]");
    EditFormParser.withFields(this.form.fields).toReading(reading);
  };

  _.write = function(reading, pageId) {
    this.pageId = pageId;

    var fields = EditFormParser.withReading(reading).toFields();
    this.form.write(fields);
  };

  _.commit = function(reading, pageId) {
    var parser = EditFormParser.withReading(reading);
    var before = this.form.toString();
    this.write(reading, pageId);
    this.store.save({pageId: pageId});
//     this.log("[edit::commit]");
  };

  _.submit = function(reading, options) {
    reading.validateForSubmit();
    var fields = GFormParser.toFields(reading, options);
    this.gform.write(fields);
    this.gstore.save(options);
    this.pending = Object.assign({reading: reading}, options);

    return this.gform.submit();
  };

  _.confirm = function() {
    this.gstore.remove();
    delete this.pending;
  };

  _.log = function(message) {
    console.log(""
      + (message || "")
      + "\n" + this.store.toString()
      + "\n" + this.gstore.toString()
    );
  };
} (jQuery));

//=require _utils.js

(function($) {
  // Imports
  var Config = $.site.Config;
  var GUI = $.site.GUI;
  var Edit = $.site.Edit;
  var Utils = $.site.Utils;
  var Reading = $.site.Reading;
  var Readings = $.site.Readings;
  var EditReading = $.site.EditReading;
  var People = $.site.People;
  var Poll = $.site.Poll;

  // Constants
  var FOR_CURRENT_QUESTION_ONLY = 1;
  var FOR_ALL_QUESTIONS_NORMAL_FIELDS = 2;
  var FOR_ALL_QUESTIONS_ALL_FIELDS = 3;

  // Controller
  var Controller = $.site.Controller = function() {
    this.onPage = this.onPage.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.onConfirm = this.onConfirm.bind(this);
    this.onDismiss = this.onDismiss.bind(this);
    this.onPrevQuestion = this.onPrevNextQuestion(-1, { preventClickedByEnterKey: true }).bind(this);
    this.onNextQuestion = this.onPrevNextQuestion( 1, { preventClickedByEnterKey: true }).bind(this);
    this.onSubmit       = this.onPrevNextQuestion( 1, { canSubmit: true                }).bind(this);
    this.onRefresh = this.onRefresh.bind(this);
    this.keydownEnterState = null;
    this.onKeydown = this.onKeydown.bind(this);
    this.onKeyup = this.onKeyup.bind(this);
    this.onDay = this.onDayNight("day").bind(this);
    this.onNight = this.onDayNight("night").bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.onStatus = this.onStatus.bind(this);
    this.config = new Config();
    this.gui = new GUI();
    this.edit = new Edit("edit-form", "g-form");
    this.readings = {data:{stays:{}}, view:{}};
  }
  var _ = Controller.prototype;

  _.init = function() {
    // Readings list load-on-scroll
    $(window).on("scroll-bottom", (function() {
      var page = this.page;
      clearTimeout(this.onScrollBottomTimeout);
      this.onScrollBottomTimeout = setTimeout((function() {
        if (page === this.page) {
          this.showMoreReadings();
        }
      }).bind(this), 50);
    }).bind(this));

    // Init subcontrollers
    this.config.init();
    People.init(this.config.people);
    this.edit.init(this.config);
    this.gui.init(this.config.urls, People, this.config.editPanels);
    this.gui.onListRefresh(this.onRefresh);
    this.gui.onEditPrev(this.onPrevQuestion);
    this.gui.onEditNext(this.onNextQuestion);
    this.gui.onEditSubmit(this.onSubmit);
    this.gui.onEditDay(this.onDay);
    this.gui.onEditNight(this.onNight);
    this.gui.onEditDelete(this.onDelete);
    this.gui.onEditStatus(this.onStatus);
    this.gui.onPopupConfirm(this.onConfirm);
    this.gui.onPopupCancel(this.onCancel);
    this.gui.onPopupDismiss(this.onDismiss);

    // Handle enter key to move between pages in edit mode
    $(window).on("keydown", this.onKeydown).on("keyup", this.onKeyup);

    // Start polling
    this.lastUpdatedPoller = Poll.add("readings-lastUpdated", this.config.urls.lastUpdated, function(csv, statusText, request, running) {
      var row = Utils.parseCsvLine(csv.split("\n")[0]);
      var newTime = Utils.toInt(row[0], 0);
      var newCount = Utils.toInt(row[1], 0);
      var stale = this.isStaleReadings(newTime, newCount);
      // console.log("[" + (stale ? "stale" : "nochange") + "] [" + this.lastUpdatedTime + "," + this.lastUpdatedCount + "] [" + newTime + "," + newCount + "]");
      this.lastUpdatedTime = newTime;
      this.lastUpdatedCount = newCount;
      if (stale) {
        this.readings.data.stale = true;
        return this.loadReadings();
      }
    }.bind(this), 5000);
  };

  _.isStaleReadings = function(timestamp, count) {
    if (this.lastUpdatedTime === undefined) { return false; }
    if (this.lastUpdatedTime != timestamp) { return true; }
    if (this.lastUpdatedCount != count) { return true; }
    return false;
  };

  _.refreshLastUpdatedUsingReadings = function() {
    var time = 0, count = 0;
    this.eachReading(function(reading) {
      if (reading.timestamp > time) { time = reading.timestamp; count = 1; }
      else if (reading.timestamp == time) { count++; }
    }, undefined, true /* Include deleted */);
    this.lastUpdatedTime = time;
    this.lastUpdatedCount = count;
  };

  _.showBuilding = function(building, reload) {
    var hash = "#" + building.toLowerCase();
    if (location.hash === hash || reload) {
      if (reload) { this.readings.data.stale = true; }
      this.hideReadings();
    }
    $.pages.showPage(hash);
  };

  _.onRefresh = function(e) {
    e.preventDefault();
    this.refreshReadings();
  };

  _.onKeydownEnter = function(e) {
    var tagName = e.target.tagName;
    this.keydownEnterState = {
      click: tagName === "A" || tagName === "BUTTON",
      ctrlKey: e.ctrlKey,
    };
  };

  _.onKeyupEnter = function(e) {
    var keydownEnterState = this.keydownEnterState;
    this.keydownEnterState = null;
    if (!(this.page.pageType === "add"
      || this.page.pageType === "edit"
    )) { return; }

    /* Allow ENTER to click links when they have focus */
    if (keydownEnterState.click) { return; }

    // Handle enter key
    e.preventDefault();
    if (this.page.state) {
      if (this.page.state === "edit-succeeded") {
        this.onDismiss();
      }
    } else {
      this.prevNextQuestion(keydownEnterState.ctrlKey ? -1 : 1);
    }
  };

  _.onKeydown = function(e) {
    switch (e.key) {
      case "Enter":
        this.onKeydownEnter(e);
        break;
    }
  };

  _.onKeyup = function(e) {
    switch (e.key) {
      case "Enter":
        this.onKeyupEnter(e);
        break;
    }
  };

  _.onPrevNextQuestion = function(direction, opts) {
    return function(e) {
      e.preventDefault();

      // Maybe abort click handling if click caused by enter key
      if (this.keydownEnterState) {
        if (this.keydownEnterState.ctrlKey
          || opts.preventClickedByEnterKey
        ) {
          this.keydownEnterState.click = false;
          return;
        }
      }

      this.prevNextQuestion(direction, opts.canSubmit);
    };
  };

  _.onDayNight = function(name) {
    return function() {
      this.gui.editShowDayNightDiff(name);
    };
  };

  _.onDelete = function(e) {
    this.page.state = "confirm-delete";
    this.gui.showPopup("delete");
    e.preventDefault();
  };

  _.onStatus = function(e) {
    var name;
    switch (Math.round(Math.random() * 3)) {
      case 0: name = "wait"; break;
      case 1: name = "ok"; break;
      case 2: name = "error"; break;
      case 3: name = "fatal"; break;
    }

    this.page.state = "test";
    this.gui.showPopup(name);
    e.preventDefault();
  };

  _.onConfirm = function() {
    if (this.page.state === "confirm-delete") {
      this.submitEdit({isDelete: true});
    } else if (this.page.state === "confirm-retry") {
      if (this.edit.pending) {
        this.submitEdit({isDelete: this.edit.pending.isDelete});
      } else {
        this.page.state = "fatal-retry";
        this.gui.showPopup("fatal");
      }
    } else if (this.page.state === "confirm-cancel" ||
               this.page.state === "confirm-no-retry" ||
               this.page.state === "test") {
      this.page.state = "cancel-succeeded";
      this.gui.dismissPopup();
    }
  };

  _.onCancel = function() {
    if (this.page.state === "confirm-delete" ||
        this.page.state === "edit-succeeded" ||
        this.page.state === "fatal-retry" ||
        this.page.state === "test") {
      this.gui.dismissPopup();

    } else if (this.page.state === "saving") {
      this.page.state = "confirm-cancel";
      this.gui.showPopup("cancel");

    } else if (this.page.state === "confirm-retry") {
      this.page.state = "confirm-no-retry";
      this.gui.showPopup("cancel");

    } else if (this.page.state === "confirm-cancel") {
      this.page.state = "saving";
      this.gui.showPopup("wait");

    } else if (this.page.state === "confirm-no-retry") {
      this.page.state = "confirm-retry";
      this.gui.showPopup("error");
    }
  };

  _.onDismiss = function() {
    this.enableEdits(FOR_ALL_QUESTIONS_NORMAL_FIELDS);

    var state = this.page.state;
    this.page.state = undefined;

    // Redirect to readings page after user submitted change (succeeded or failed)
    if (state === "edit-succeeded" ||
        state === "cancel-succeeded" ||
        state === "fatal-retry") {

      // Clear edits
      this.edit.reset(true, true);

      var reload = false;

      // Force reload data if user aborted submit, because something may have gone wrong
      if (state === "cancel-succeeded" ||
          state === "fatal-retry") {
        reload = true;
      }

      // Redirect
      this.showBuilding(this.page.building, reload);
      this.gui.focusTop();
    }
  };

  _.start = function() {
    $(window).on("page.pages", this.onPage);
    $.pages.start(new $.site.PagesPollOptions());
  };

  _.onPage = function(event, page) {
    $.onScrollBottom.enabled(false);
    clearTimeout(this.onScrollBottomTimeout);
    clearTimeout(this.asyncPageLoadTimeout);
    delete this.asyncPageLoadTimeout;
    delete this.onScrollBottomTimeout;
    scrollTo(0, 0);
//     $(document.activeElement).blur();

    if (!this.initialised) { this.initialised = true; this.init(); }

    var parts = page.path.split("/");
    var part;

    // Get home
    part = (part = parts.shift()) && part.toLowerCase();
    if (part === "" || part === "home") {
      page.pageType = "home";
      part = (part = parts.shift()) && part.toLowerCase();
    }

    // Get building
    if (part === "barn") {
      page.building = "Barn";
      page.otherBuilding = "Cottage";
    } else {
      page.building = "Cottage";
      page.otherBuilding = "Barn";

      if (part !== "cottage" &&
        page.path !== "") {

        page.setHash("");
        page.pageType = "home";
        parts = [];
      }
    }

    // Get page type
    if (!page.pageType) { page.pageType = (part = parts.shift()) && part.toLowerCase() || "list"; }

    // Validate pageType
    if (!(page.pageType === "home" ||
          page.pageType === "add" ||
          page.pageType === "edit" ||
          page.pageType === "list" ||
          page.pageType === "delete"))
    {
      page.setHash(page.building.toLowerCase());
      page.pageType = "list";
      parts = [];
    }

    // Detect delete
    var isDelete = page.pageType === "delete";
    if (isDelete) {
      page.pageType = "edit";
      page.state = "confirm-delete";
      page.setHash(page.hash.replace(/\/delete/, "/edit"));
    }

    // Get page number
    if (page.pageType === "add" ||
        page.pageType === "edit") {

      if (page.pageType === "edit") {
        page.readingId = parts.shift();
      }
      page.panelName = (part = parts.shift()) && part.toLowerCase();
      page.panel = this.config.editPanels.byName[page.panelName];
    }

    page.valid = true;
    page.href = page.hash;
    this.page = page;
    this.gui.showPage(page);

    // Prevent caching changes when leave edit mode
    if (page.pageType !== "add" &&
        page.pageType !== "edit") {
      this.edit.reset(true);
    }

    if (page.pageType !== "list") {
      this.hideReadings();
    }

    if (page.pageType !== "home") {
      this.loadReadings();
    }
  };

  _.loadReadings = function() {
    if (this.readings.data.loaded &&
       !this.readings.data.stale) {

      if (this.readings.data.loading) {
        this.page.async = true;
        return this.readings.data.loading;
      } else {
        this.page.async = false;
        this.refreshReadings();
        return $.Deferred().resolve().promise();
      }
    } else {
      this.page.async = true;
//       this.hideReadings();
      var data = this.readings.data;
      var cache = !data.stale;
      data.stale = false;
      data.loaded = false;

      // Load from cache
      if (cache) {
        var csv = localStorage.getItem("readings");
        if (csv) {
          var valid = false;
          try {
            Readings.parseCsv(csv, data);
            valid = true;
          } catch (err) {
            // Cache is corrupt
          }
          if (valid) {
            this.loadedReadings(data);
            return $.Deferred().resolve().promise();
          }
        }
      }
      localStorage.removeItem("readings");

      // Load from url
      var logging = this.config.logging;
      if (logging && console.time) { console.time("load readings"); }
      return (data.loading = $.ajax({url: this.config.urls.readings, cache: false})
      .done((function(csv) {
        if (logging && console.timeLog) { console.timeLog("load readings"); }
        Readings.parseCsv(csv, data);
        if (!data.stale) {
          localStorage.setItem("readings", csv);
        }
        this.loadedReadings(data);
      }).bind(this))
      .always((function() {
        if (logging && console.timeEnd) { console.timeEnd("load readings"); }
        data.loading = false;
      }).bind(this))
      .promise());
    }
  };

  _.loadedReadings = function(data) {
    data.loaded = true;

    // Ensure we're up-to-date
    this.refreshLastUpdatedUsingReadings();

    // Check the edit succeeded
    this.confirmEditSucceededUsingReadings();

    // Render page content
    if (!this.page.state) {
      if (this.edit.pending) {
        this.page.state = "saving";
        this.gui.showPopup("wait");

      } else if (this.page.pageType === "list" &&
        this.readings.view.visibleStaysCount > 0) {
        this.gui.listShowRefresh(this.page);

      } else {
        this.refreshReadings();
      }
    }
  };

  _.eachReading = function(callback, thisArg, includeDeleted) {
    Utils.forEach(callback, thisArg,
      this.readings.data.cottage.list,
      this.readings.data.barn.list,
      (includeDeleted ? this.readings.data.cottage.deleted : undefined),
      (includeDeleted ? this.readings.data.barn.deleted : undefined)
    );
  };

  _.refreshReadings = function() {
    this.hideReadings();
    this.showReadings();
  };

  _.hideReadings = function() {
    $("#readings .s-reading-detail-row").collapse("hide");
    $("#readings > *").addClass("d-none s-unused");
    this.readings.view.visibleStaysCount = 0;
    this.gui.showReading($("#reading"), null);
    this.gui.listHideRefresh(this.page);

    // Add / Edit
    if (this.page.pageType === "add" ||
        this.page.pageType === "edit") {

      this.enableEdits(false);
      this.edit.reset();
    }
  };

  _.showReadings = function() {
    this.gui.showPage(this.page);

    var building = this.page.building.toLowerCase();
    var readings = this.readings.data.active = this.readings.data[building];
    this.readings.data.stays.active = this.readings.data.stays[building];

    if (readings.list.length > 0) {
      this.gui.showReading($("#reading"), readings.list[0]);

      // List
      if (this.page.pageType === "list") {
        if (!this.page.async) {
          this.page.async = true;
          this.asyncPageLoadTimeout = setTimeout(this.showMoreReadings.bind(this), 50);
        } else {
          this.showMoreReadings();
        }

      // Add / Edit
      } else if (this.page.pageType === "add" ||
                 this.page.pageType === "edit") {

        this.showQuestion();

        // Delete popup
        if (this.page.state == "confirm-delete") {
          this.gui.showPopup("delete");
        }
      }
    }
  }

  _.showMoreReadings = function() {
    // console.time("readings");

    var building = this.page.building.toLowerCase();

    var $template = $($("#readings-row-template")[0].content);
    var numberOfNodesPerStay = $template.children().get().length;

    var $stays = $("#readings");
    var unusedStaysNodes = $stays.find("> .s-unused").get();
    var unusedStaysCount = unusedStaysNodes.length / numberOfNodesPerStay;

    var view = this.readings.view;
    var stays = this.readings.data.stays.active;

    var limit = view.visibleStaysCount + 20;
    var reusedCount = 0;
    var added = [];

    for (var i = view.visibleStaysCount; i < stays.length; i++) {
      var stay = stays[i];
      var prevStay = stays[i-1];

      if (view.visibleStaysCount >= limit &&
         !stay.isSameMonth(prevStay)) { break; }

      var $stayElem;
      var isStayElemReused;
      if (reusedCount < unusedStaysCount) {
        var index = reusedCount * numberOfNodesPerStay;
        $stayElem = $(unusedStaysNodes.slice(index, index + numberOfNodesPerStay))
        $stayElem.removeClass("d-none");
        reusedCount++;
        isStayElemReused = true;
      } else {
        $stayElem = $(document.importNode($template[0], true));
        added.push($stayElem);
        $stayElem = $stayElem.children();
        isStayElemReused = false;
      }

      var $yearRow = $stayElem.filter(".s-reading-year-row");
      var $monthRow = $stayElem.filter(".s-reading-month-row");
      var $dateRow = $stayElem.filter(".s-reading-date-row");
      var $contentRow = $stayElem.filter(".s-reading-content-row");
      var $detailRow = $stayElem.filter(".s-reading-detail-row");

      var isSameYear = stay.isSameYear(prevStay);
      var isSameMonth = stay.isSameMonth(prevStay);
      var isSameDate = stay.isSameDate(prevStay);

      if (isSameYear) {
        $yearRow.addClass("d-none");
      } else {
        $yearRow
          .removeClass("d-none")
          .toggleClass("mt-4", view.visibleStaysCount != 0)
          .find(".s-reading-year")
          .text(stay.startReading.whenDate.getFullYear());
      }

      if (isSameMonth) {
        $monthRow.addClass("d-none");
      } else {
        $monthRow
          .removeClass("d-none")
          .toggleClass("mt-4", isSameYear)
          .find(".s-reading-month")
          .text(Utils.formatLongMonth(stay.startReading.whenDate));
      }

      if (isSameDate) {
        $dateRow.addClass("d-none");
      } else {
        $dateRow
          .removeClass("d-none")
          .find(".s-reading-date")
          .text(Utils.formatLongDate(stay.startReading.whenDate));
      }

      // People
      this.appendPeople($contentRow.find(".s-reading-people").empty(), stay.stayers);

      // Cost
      var cost = "£" + stay.cost.toFixed(2);
      $contentRow.find(".s-reading-cost").text(cost);
      var days = !stay.endReading ? "In Progress" : "" + stay.days + " day" + (stay.days == 1 ? "" : "s");
      $contentRow.find(".s-reading-days").text(days);

      // Detail
      var contentId = "reading" + view.visibleStaysCount;
      var detailId = contentId + "Detail";
      $contentRow.attr("id", contentId).attr("href", "#" + detailId).attr("aria-controls", detailId);
      $detailRow.attr("id", detailId).attr("aria-controller", contentId);
      if (!isStayElemReused) { this.gui.onDetailRowCollapsing($detailRow); }
      var $readingStart = $detailRow.find(".s-reading-start-row");
      $readingStart.toggleClass("s-reading-corrupt", !!stay.startReading.isCorrupt);
      $readingStart.find(".s-reading-when").text(Utils.formatShortDate(stay.startReading.whenDate));
      $readingStart.find(".s-reading-day").text(stay.startReading.day);
      $readingStart.find(".s-reading-night").text(stay.startReading.night);
      var $readingEnd = $detailRow.find(".s-reading-end-row").toggle(!!stay.endReading);
      if (stay.endReading) {
        $readingEnd.toggleClass("s-reading-corrupt", !!stay.endReading.isCorrupt);
        $readingEnd.find(".s-reading-when").text(Utils.formatShortDate(stay.endReading.whenDate));
        $readingEnd.find(".s-reading-day").text(stay.endReading.day);
        $readingEnd.find(".s-reading-night").text(stay.endReading.night);
      }
      var $readingRates = $detailRow.find(".s-reading-rate-row");
      $readingRates.find(".s-reading-day").text(stay.dayRate.toFixed(2) + "p");
      $readingRates.find(".s-reading-night").text(stay.startReading.isEmpty ? "Empty" : (stay.nightRate.toFixed(2) + "p"));

      // Edit links
      var identifier = stay.startReading.identifier;
      var nextIdentifier = stay.endReading ? stay.endReading.identifier : undefined;
      var $startActions = $readingStart.find(".s-reading-actions").toggle(!!identifier);
      var $endActions = $readingEnd.find(".s-reading-actions").toggle(!!nextIdentifier && !stay.chained);
      $startActions.find(".s-reading-action-edit").attr("href", "#" + building + "/edit/" + identifier);
      $startActions.find(".s-reading-action-delete").attr("href", "#" + building + "/delete/" + identifier);
      $endActions.find(".s-reading-action-edit").attr("href", "#" + building + "/edit/" + nextIdentifier);
      $endActions.find(".s-reading-action-delete").attr("href", "#" + building + "/delete/" + nextIdentifier);

      view.visibleStaysCount++;
    }

    // Insert into DOM
    if (reusedCount > 0) {
      $(unusedStaysNodes.slice(0, reusedCount * numberOfNodesPerStay)).removeClass("s-unused");
    }
    $stays.append(added);

    // console.timeEnd("readings");

    // Show more on scroll bottom
    if (view.visibleStaysCount < stays.length) {
      $("#readings-more-spacer")
        .removeClass("d-none")
        .height(500);
      $.onScrollBottom.enabled(550);
    } else {
      $("#readings-more-spacer").addClass("d-none");
    }
  };

  _.appendPeople = function($peopleElem, initials) {
    initials.forEach(function(initial) {
      var image = People.image[initial];
      var $personElem = $(document.createElement("img"));
      $personElem.addClass("s-reading-person");
      $personElem.attr("src", image);
      $peopleElem.append($personElem);
    });
  };

  _.getEditQuestionHash = function(questionNumber) {
    return this.getEditPageHash() + "/" + questionNumber;
  };

  _.getEditPageHash = function() {
    var result = "#" + this.page.building.toLowerCase() + "/" + this.page.pageType;
    if (this.page.pageType === "edit") {
      result += "/" + this.page.readingId;
    }
    return result;
  };

  _.prevNextQuestion = function(direction, canSubmit) {
    if (direction > 0) { if (!this.page.nextPanel && !canSubmit) { return; } }
    else               { if (!this.page.prevPanel) { return; } }

    this.commitQuestion(); // Enables all fields
    this.validateQuestion();

    // Prevent move - error on current page
    if (direction > 0 && this.page.error) {
      this.gui.showQuestion(this.page);
      this.enableEdits(FOR_CURRENT_QUESTION_ONLY);
      return;
    }

    var panelName = this.page.panelName;
    var panelToShow = direction > 0 ? this.getNextQuestion(panelName) : this.getPrevQuestion(panelName);

    // Move
    if (panelToShow) {
      this.gui.focusPrevNextButton(direction);
      location.href = this.getEditQuestionHash(panelToShow.name);
      return;
    }

    // Submit
    if (direction > 0 && canSubmit) {
      this.submitEdit();
      return;
    }

    // No move
    this.enableEdits(FOR_CURRENT_QUESTION_ONLY);
  };

  _.submitEdit = function(options) {
    options = options || {};
    options.page = this.getEditPageHash();
    options.lastUpdatedTime = this.lastUpdatedTime;
    this.enableEdits(false);
    this.page.state = "saving";
    this.gui.showPopup("wait");
    return this.edit.submit(this.readings.data.edit, options).then(function() {
      this.lastUpdatedPoller.poll([500,500,500,500,500,500,500,500,500,500]); // Check for updates sooner
    }.bind(this)).catch(function(e) {
      console.log("Failed: " + e);
      this.page.state = "confirm-retry";
      this.gui.showPopup("error");
    }.bind(this));
  };

  _.instantiateEditReading = function(pageId) {
    var readingsData = this.readings.data;

    // Reuse existing EditReading
    if (this.edit.pageId === pageId &&
        readingsData.edit)
    {
      return readingsData.edit;
    }

    // Make new EditReading
    var reading;
    var readings = readingsData.active;
    readingsData.edit = null;

    // Add
    if (this.page.pageType === "add") {
      var previous = readings[0];
      reading = new Reading(undefined, new Date(), (previous ? previous.day : undefined), (previous ? previous.night : undefined));
      reading.readings = readings;
      reading.index = -1;

    // Edit
    } else {
      for (var i = 0; i < readings.list.length; i++) {
        if (readings.list[i].identifier === this.page.readingId) {
          reading = readings.list[i];
          break;
        }
      }

      // Reading doesn't exist
      if (!reading) {
        location.href = "#" + this.page.building.toLowerCase();
        return;
      }
    }

    return readingsData.edit = new EditReading(reading);
  };

  _.refreshEditReading = function() {
    var pageId = this.getEditPageHash();
    var editReading = this.instantiateEditReading(pageId);

    // Stored edits are still valid, so load them in
    // EditForm --> EditReading
    if (this.edit.store.data.pageId === pageId) {
      this.edit.read(editReading, true); // Load from store
      if (editReading.dirty.all.is.when) {
        this.refreshEditReadingIndex();
      }
      editReading.validate();
    }


    // The EditReading is the golden source, and may have changed. Always write out
    // to form so GUI is in sync.
    // EditReading --> EditForm
    this.edit.write(editReading, pageId);

    // Reset dirty
    editReading.dirty.commit();
  };

  _.showQuestion = function() {
    // Otherwise serialize form returns nothing
    this.enableEdits(FOR_ALL_QUESTIONS_ALL_FIELDS);

    // Calculate questions, based on answers so far
    this.refreshEditReading();
    this.refreshQuestions();
    this.refreshQuestionFields();
    this.setQuestion();
    this.gui.showQuestion(this.page);

    // Prevent tab focus on hidden inputs
    this.enableEdits(FOR_CURRENT_QUESTION_ONLY);
  };

  _.refreshQuestions = function() {
    var edit = this.readings.data.edit;
    var oldOccupants = Object.keys(edit.oldOccupants).length;
    var newOccupants = Object.keys(edit.newOccupants).length;
    var questions = this.page.questions = {
      when:     {ask:true},
      leaving:  {ask:oldOccupants > 0},
      arriving: {ask:oldOccupants < People.initials.length},
      guest:    {ask:newOccupants > 0},
      empty:    {ask:newOccupants > 0},
      daynight: {ask:true}
    };
    if (questions.arriving.ask) {
      if (oldOccupants === 0 && newOccupants === 0) {
        questions.arriving.error = "You must select at least one person!";
      }
    }
  };

  _.isAskedQuestion = function(name) {
    var question = this.page.questions[(name || this.page.panelName)];
    return question && question.ask;
  };

  _.getQuestionError = function(name) {
    var question = this.page.questions[(name || this.page.panelName)];
    return question && question.error;
  };

  _.getErroredQuestion = function() {
    return this.findQuestion(0, 1, function(panel, error) {
      if (error) {
        return panel;
      }
    });
  };

  _.getPrevNextQuestion = function(name, direction) {
    return this.findQuestion(name, direction, function(panel) {
      if (panel.name !== name) { return panel; }
    });
  };

  _.getPrevQuestion = function(name) { return this.getPrevNextQuestion(name, -1); };
  _.getNextQuestion = function(name) { return this.getPrevNextQuestion(name, 1); };

  _.findQuestion = function(start, direction, callback) {
    var editPanels = this.config.editPanels;
    var questions = this.page.questions;
    var handler = function(i) {
      var panel = editPanels.all[i];
      var status = panel && questions[panel.name];
      if (status && status.ask) { return callback(panel, status.error); }
    }

    // Get start index
    var i;
    if (typeof start !== "string") {
      i = start;
    } else {
      var panel = editPanels.byName[start];
      if (!panel) { return undefined; }
      i = panel.index;
    }

    // Loop
    var result;
    if (direction < 0) {
      for (; i >= 0; i--) { if ((result = handler(i))) { break; } }
    } else {
      var count = Object.keys(questions).length;
      for (; i < count; i++) { if ((result = handler(i))) { break; } }
    }
    return result;
  };

  _.setQuestion = function() {
    var origPanel = this.config.editPanels.byName[this.page.panelName];
    var panel = origPanel;
    if (!panel || !this.isAskedQuestion(panel.name)) {
      if (!panel) {
        panel = this.config.editPanels.defaultPanel;
        if (!this.isAskedQuestion(panel.name)) { panel = undefined; }
      }

      if (!panel) {
        if (panel !== this.config.editPanels.defaultPanel) { panel = this.getPrevQuestion(panel.name); }
        if (!panel) { panel = this.getNextQuestion(panel.name); }
      }
    }

    var errored = this.getErroredQuestion();
    if (errored &&
        errored.index < panel.index)
    {
      panel = errored;
      this.page.error = this.getQuestionError(errored.name);
    }

    if (panel !== origPanel) {
      this.page.panelName = panel.name;
      this.page.panel = panel;
      this.page.setHash(this.getEditQuestionHash(panel.name));
    }

    this.page.prevPanel = this.getPrevQuestion(panel.name);
    this.page.nextPanel = this.getNextQuestion(panel.name);
    this.page.isSubmitNext = !this.page.nextPanel;
  };

  _.validateQuestion = function() {
    this.page.error = this.getQuestionError();
  };

  _.enableEdits = function(mode) {
    // Disable
    if (mode === false) {
      this._toggleEdits(false);
      return;
    }

    // Enable all questions' fields, maybe including killed fields
    this._toggleEdits(true, mode === FOR_ALL_QUESTIONS_ALL_FIELDS);

    // Disable other questions's fields to prevent tab focus on hidden inputs
    if (mode === FOR_CURRENT_QUESTION_ONLY) {
      var $hiddenQuestionsInputs = this.edit.form.$().findTop(".d-none").formInputs();
      $hiddenQuestionsInputs.filter(":focus").trigger("blur");
      $hiddenQuestionsInputs.toggleEnabled(false);
    }
  };

  _._toggleEdits = function(enabled, all) {
    this.edit.form.$().formInputs().toggleEnabled(enabled, { canEnableKilled: all });
  };

  _.commitQuestion = function() {
    // Re-enable all valid offscreen fields, so the read gets their data
    this.enableEdits(FOR_ALL_QUESTIONS_NORMAL_FIELDS);

    // Read user edits from form
    var editReading = this.readings.data.edit;
    this.edit.read(editReading);

    // Date changed
    if (editReading.dirty.uncommitted.is.when) {
      this.refreshEditReadingIndex();

      // Previous user selections for people leaving/arriving may now be invalid, so reset.
      if (editReading.dirty.uncommitted.is.index) {
        var dirty = editReading.dirty.uncommitted.snapshot();
        editReading.dirty.clean();
        editReading.when = dirty.when;
        editReading.index = dirty.index;
      }
    }

    // Validate changes
    editReading.validate();

    // Re-enable all offscreen fields, including invalid, so can write to them
    this.enableEdits(FOR_ALL_QUESTIONS_ALL_FIELDS);

    // Commit validated edits to form
    this.edit.commit(editReading, this.getEditPageHash());

    // Clear dirty after committing edits, because commit logic may have needed to know what's changed
    editReading.dirty.commit();

    this.refreshQuestions();

//     console.log("COMMITTED\n\n" + JSON.stringify(editReading, undefined, "\t"));
  };

  _.refreshEditReadingIndex = function() {
    var editReading = this.readings.data.edit;
    var readings = editReading.readings.list;

    if (!editReading.when) {
      if (!editReading.identifier) {
        editReading.index = -1;
      } else {
        for (var i = 0; i < readings.length; i++) {
          if (readings[i].identifier === editReading.identifier) {
            editReading.index = i;
            break;
          }
        }
      }
    } else {
      for (var i = 0; i < readings.length; i++) {
        if (readings[i] === editReading.reading) { continue; }
        if (readings[i].when <= editReading.when) {
          editReading.index = i - 1;
          break;
        }
      }
    }
  };

  _.refreshQuestionFields = function() {
    var editReading = this.readings.data.edit;

    // Day / Night thresholds
    var prevReading = editReading.previous;
    var minDay = prevReading ? prevReading.day : 0;
    var minNight = prevReading ? prevReading.night : 0;
    var defaultDay = editReading.reading ? editReading.reading.day : undefined;
    var defaultNight = editReading.reading ? editReading.reading.night : undefined;
    if (defaultDay === undefined) { defaultDay = minDay; }
    if (defaultNight === undefined) { defaultNight = minNight; }
    $("#edit-day").numberRange(defaultDay, minDay, 99999);
    $("#edit-night").numberRange(defaultNight, minNight, 99999);

    // Day / Night deltas
    this.onDay();
    this.onNight();

    // Arriving / leaving people choices
    $("#edit-container .s-edit-person-container").addClass("d-none").formInputs().toggleKilled(true);
    for (var initial in editReading.newOccupants) {
      var defaultOccupants = editReading.reading ? editReading.reading[initial] : undefined;
      if (defaultOccupants === undefined) { defaultOccupants = editReading.prevReading ? editReading.prevReading[initial] : undefined; }
      if (defaultOccupants === undefined) { defaultOccupants = 1; }
      $("#edit-guest-" + initial + "-container").removeClass("d-none").formInputs().toggleKilled(false).numberRange(defaultOccupants - 1, 0, 10);
    }
    for (var initial in editReading.oldOccupants) {
      $("#edit-leaving-" + initial + "-container").removeClass("d-none").formInputs().toggleKilled(false);
    }
    People.initials.forEach(function(initial) {
      if (editReading.oldOccupants[initial]) {
        // Was there before, but still there after, so show as 'arriving', but can't change it
        if (editReading.newOccupants[initial]) {
          $("#edit-arriving-" + initial + "-container").removeClass("d-none").formInputs().prop("checked", true);
        }
      } else {
        // Wasn't there before, so can be arriving
        $("#edit-arriving-" + initial + "-container").removeClass("d-none").formInputs().toggleKilled(false);
      }
    });

    // Date placeholder
    var when = editReading.reading && editReading.reading.whenDate || new Date();
    $("#edit-when-date").numberRange(Utils.formatDateDay(when), 1, 31);
    $("#edit-when-month").numberRange(Utils.formatDateMonth(when), 1, 12);
    $("#edit-when-year").numberRange(Utils.formatDateYear(when), 0, 9999);
  };

  _.confirmEditSucceededUsingReadings = function() {
    var pending = this.edit.pending;
    if (!pending) { return; }

    var confirmed = false;

    // Delete
    if (pending.isDelete) {
      var found = false;
      this.eachReading(function(reading) {
        if (reading.identifier === pending.reading.identifier) {
          found = true;
          return false;
        }
      });

      confirmed = !found;

    // Add / edit
    } else {
      var lastUpdatedTime = Utils.toInt(pending.lastUpdatedTime, 0);
      var found = false;

      this.eachReading(function(reading) {
        if (reading.timestamp > lastUpdatedTime) {
          found = true;
          return false;
        }
      });

      confirmed = found;
    }

    // Check confirmed
    if (confirmed) {
      this.page.state = "edit-succeeded";
      this.gui.showPopup("ok");
      this.edit.confirm();
    }
  };
})(jQuery);


(function($) {    
  var controller = new $.site.Controller();
  controller.start();
} (jQuery));
